import $ from 'jquery';
import jsonpack from 'jsonpack';
import React from 'react';
import ReactToolTip from 'react-tooltip';
import { getInstMessage } from '../../../constants/instMessgMapper';
import i18n from '../../../i18n';
import FlavorService from '../../../services/flavor.service';
import { loginService } from '../../../services/login.service';
import RegionService from '../../../services/region.service';
import HeaderTop from '../../common/headerTop/headerTop';
import NotificationSlider from '../../common/topRightHeader/notificationSlider';
import Survey from '../survey';
import { API_HOST, axiosInstance, axiosRequestWithAuth, EMAIL_TRANSFER_TOKEN } from './../../../constants/server.constant';
import { AuditLog } from './../../../services/auditlog.service';
import { BackupService } from './../../../services/backup.service';
import { NetworkService } from './../../../services/network.service';
import { ResourceService } from './../../../services/resource.service';
import { ServerService as instanceService } from './../../../services/server.service';
import { SessionService } from './../../../services/session.service';
import CommonMessage from './../../common/commonMessage';
import LeftNav from './../../common/leftnav/leftnav';
import InstanceMigration from './instanceMigration';

export default class InstanceNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flavorList: [],
            loading: true,
            servers: [],
            filteredData: [],
            nametoggle: true,
            regiontoggle: true,
            statustoggle: true,
            datetoggle: true,
            dropDown: 'All Instances',
            listTimerSubscriber: '',
            selectedInstanceId: '',
            selectedInstanceName: '',
            selectedFlavorId: '',
            computeRegionUrl: '',
            imageRegionUrl: '',
            isAction: false,
            message: '',
            msgType: '',
            searchInput: '',
            sortColumn: 'date',
            selectedInstance: {},
            dropDownStatus: 'All Instances',
            isCopied: false,
            isUserSubscribed: false,
            isClone: false,
            cloneList: [],
            regionList: [],
            isRegionStatus: false,
            regionCount: 0,
            regionString: "",
            isCluster: "",
            currentFlavType: "",
            currentStatus: "",
            currentFault: "",
            isConsole: "show",
            backUpList: [],
            showBanner: false,
            indexCount: 0,
            count: 50,
            migList: [],
            userId: localStorage.getItem('userId'),
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.deleteClick = this.deleteClick.bind(this);
        this.goToSummary = this.goToSummary.bind(this);
        this.setSortable = this.setSortable.bind(this);
        this.bnDropdownClick = this.bnDropdownClick.bind(this);
        this.btnCancelClick = this.btnCancelClick.bind(this);
        this.headerSortClick = this.headerSortClick.bind(this);
        this.handleDropdown = this.handleDropdown.bind(this);
        this.getConsole = this.getConsole.bind(this);
        this.getFlavorDetailsById = this.getFlavorDetailsById.bind(this);
        this.getBackUpInstances = this.getBackUpInstances.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.pageNumFocus = React.createRef();
        this.instMig = React.createRef();
        document.title = 'IDrive® Compute';
    }

    componentDidMount() {
        localStorage.removeItem("emailToken");
        this.setState({ isAction: true });

        sessionStorage.isInstanceLoaded = "false";
        if(localStorage.getItem("_banner_show") !== "hide") {
            localStorage.setItem("_banner_show", "show");
        }
        if(localStorage.getItem("_cmplt_banner_show") !== "hide") {
            localStorage.setItem("_cmplt_banner_show", "show");
        }
        if(typeof this.props.location.state !== 'undefined') {
            if(this.props.location.state.val != null) {
                if(this.props.location.state.val === "BM_SUBMIT") {
                    if(localStorage.getItem("bmMsg") === "show") {
                        this.setState({
                            message: "Bare Metal request has been successfully submitted",
                            msgType: ""
                        });
                        localStorage.removeItem("bmMsg");
                    }
                    else {
                        this.setState({
                            message: "",
                            msgType: ""
                        });
                    }

                }
            }
            console.debug(this.props.location.state);
            if(this.props.location.state.emailTransfer) {
                debugger;
                let data = this.props.location.state.emailTransfer;
                if(data?.ok && data?.emailTransfer) {
                    loginService.deleteCookie(EMAIL_TRANSFER_TOKEN, "/api");
                    this.setState({
                        message: "Your email address has been verified and updated to <b>" + data.emailTransfer.new_email + "</b>. Contact <a href=\"https://www.idrivecompute.com/support.htm\" target=\"blank\" rel=\"noopener noreferrer\">support</a> if you have not made this change.",
                        msgType: "success",
                    });
                } else {
                    debugger;
                    console.log(data.error);
                    let message = "";
                    switch(data?.error) {
                        case "malformed_request":
                            message = "The email update request could not be processed since it has expired or is not valid. Please check and try again.";
                            break;
                        case "token_not_found":
                            break;
                        case "field_taken":
                            message = "The email update request could not be processed since the email address requested is no longer available. Please check and try again.";
                            break;
                        case "entity_not_found":
                            message = "The email update request could not be processed since it has been cancelled or is not valid. Please check and try again.";
                            break;
                        default:
                            message = "Error while processing email update request.";
                            break;
                    }
                    this.setState({
                        message: message,
                        msgType: "error",
                    });
                }
                let prevState = { ...this.props.location.state };
                delete prevState.emailTransfer;
                window.history.replaceState(prevState, document.title);
            }
        }
        this.getAdditionalIpDetails();
        this.getBackUpInstances("onLoad");
        var cloneMsg = localStorage.getItem("cloneMsg");
        if(cloneMsg !== null && cloneMsg !== undefined) {
            this.setState({ message: cloneMsg });
            localStorage.removeItem("cloneMsg");
        }
        if(this.state.isCreateExternalDisabled) {
            // this.setState({
            //     message: "Due to various factors we are discontinuing our services in all the regions with effect from 06-26-2023. After the closure you will not be able to access your resources and data. Thank you for using our services. <br/> Contact <a href=\"https://www.idrivecompute.com/support.htm\" target=\"blank\" rel=\"noopener noreferrer\">support</a> for any queries.",
            //     msgType: "success",
            // });
            // this.setState({
            //     message: "We are currently not supporting <b>instance creation</b> due to limited capacity.",
            //     msgType: "error"
            // });
        }
    }

    checkForSubscription = () => {
        this.setState({ isAction: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"
                });
            }
            else if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
            }
            else {
                this.setState({
                    isUserSubscribed: true,
                });
                this.setRegionListByType('compute');
                this.setRegionListByType('image');
                this.getMaintananceRegions();

                var cluster = localStorage.getItem("clusterMessage");
                if(cluster !== null && cluster !== undefined) {
                    this.setState({
                        isCluster: localStorage.getItem("clusterMessage")
                    });
                }
                else {
                    localStorage.setItem("clusterMessage", "show");
                    this.setState({
                        isCluster: "show"
                    });
                }
                this.getCloneList();
                this.getMigrationList();
                let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
                if(fullRegionList === null || fullRegionList === undefined) {
                    RegionService.getAll().then(resp => {
                        this.callServerCallType();
                    });
                } else {
                    this.callServerCallType();
                }

            }

        });
    };
    callServerCallType() {
        this.getJsonPackInstData();
        if(this.props.location.state && this.props.location.state.val === 'server created') {
            this.getServerList(true);
        } else {
            this.getServerList(false);
        }
        this.doPolling();
    }
    checkBackUpInstances = (id) => {
        let list = this.state.backUpList;
        for(let i = 0; i < list.length; i++) {
            if(list[i].instance_id == id) {
                return false;
            }
        }
        return true;
    };
    closeBanner = (server) => {
        localStorage.setItem("_banner_show", "hide");
        localStorage.setItem("_cmplt_banner_show", "hide");
        this.getServerList(true);
        this.setState({
            showBanner: false
        });
    };
    checkDate = (date) => {
        var i = date;
        i = i.substring(0, i.length - 2);

        var today = new Date();
        var instance = new Date(i);


        var Difference_In_Time = Math.abs(instance - today) / 1000;

        // To calculate the no. of days between two dates
        var Difference_In_Days = Math.floor(Difference_In_Time / (60 * 60 * 24));
        if(Difference_In_Days == 0) {
            return true;
        }
        else {
            return false;
        }

    };
    getBackUpInstances = (param) => {
        let userId = localStorage.getItem("userId");

        axiosInstance.get(API_HOST + "/backup/getbackups/" + userId, axiosRequestWithAuth).
            then(resp => {

                let res = resp.data;
                this.setState({
                    backUpList: res
                }, () => {
                    this.setFlavorDetails();
                });
                if(param == "loaded") {
                    this.getServerList(true);
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    createSchedule(instanceId, name, region, instance) {
        let computeRegionUrl = this.getRegionUrl(instance.region, 'compute');
        let imageRegionUrl = this.getRegionUrl(instance.region, 'image');
        this.setState({
            isAction: true
        });
        let requestBody = {
            instance_id: instanceId,
            name: name,
            region: region,
            type: "daily"
        };
        BackupService.createSchedule(requestBody).then(resp => {
            if(resp == "INSTANCE_ALREADY_EXISTS") {
                this.setState({ isAction: false });
                this.moveToPage("/server/backups", instanceId, computeRegionUrl, imageRegionUrl, instance);
                return;
            }
            if(resp && resp.id) {
                SessionService.setCookie("_message_backup", "show");
                const enableBack = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + name + " has been enabled for daily backup",
                    "region": region,
                    "operation": "Backup Enabled"
                };
                AuditLog.storeAuditLogs(enableBack, "instance").then((resp) => {
                    if(resp === false);
                });

                //this.getBackupImageList();
                //let time = this.getAfterTime(scheduletype)
                //successMessag = successMessag + time

                this.setState({ isAction: false });
                this.moveToPage("/server/backups", instanceId, computeRegionUrl, imageRegionUrl, instance);


                //this.setState({isdisabled:true})
                return;
            }
            this.setState({ isAction: false });
            this.setState({ message: i18n.t("inst_bckp_Crea_failure"), msgType: 'error' });

        });

    }

    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {

                let res = resp.data;
                let string = "";
                this.setState({
                    regionCount: res.length,
                    regionList: res
                });
                if(res.length > 0) {
                    for(let i = 0; i < res.length; i++) {
                        string += res[i].name + " (" + res[i].region_id + ")" + ", ";
                    }
                    this.setState({
                        isRegionStatus: true,
                        regionString: string.replace(/,\s*$/, "")
                    });
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    doPolling() {
        sessionStorage.instanceListInterval = setInterval(() => this.getServerList(true), 10000);
    }

    getCloneList() {
        instanceService.getCloneList('clone').then(resp => {
            if(Array.isArray(resp)) {
                let ob = resp.find(item => item.status === 'Cloning failed');
                if(ob !== undefined) {
                    this.setState({ message: 'Cloning failed for the instance ' + ob.instanceName + ' . Try again to clone the instance.' });
                    if(resp.length === 1) {
                        this.setState({ cloneList: [], isClone: false });
                        clearTimeout(sessionStorage.cloneListInterval);
                    }
                }
                if(this.state.cloneList.length > 0 && resp.length !== this.state.cloneList.length) {
                    this.getServerList(true);
                    this.doInstanceCloneTimeout();
                }
                if(resp.length > 0) {
                    this.setState({ isClone: true, cloneList: resp });
                    this.doCloneTimeout();
                }
                if(resp.length === 0) {
                    this.onCloneClose();
                    this.setState({ isClone: false, cloneList: [] });
                }
            } else {
                this.onCloneClose();
                this.setState({ isClone: false, cloneList: [] });
            }
        });
    }
    getMigrationList() {
        instanceService.getCloneList('migration').then(resp => {
            if(Array.isArray(resp)) {
                let ob = resp.find(item => item.status === 'Migration failed');
                if(ob !== undefined) {
                    this.setState({ message: 'Migration failed for the instance ' + ob.instanceName + ' . Try again to clone the instance.' });
                    if(resp.length === 1) {
                        this.setState({ migList: [], isMigration: false });
                        clearTimeout(sessionStorage.migListInterval);
                    }
                }
                if(this.state.migList.length > 0 && resp.length !== this.state.migList.length) {
                    this.getServerList(true);
                    this.doMigTimeout();
                }
                if(resp.length > 0) {
                    this.getServerList(true);
                    this.setState({ isMigration: true, migList: resp });
                    this.doMigTimeout();
                }
                if(resp.length === 0 && resp.length !== this.state.migList.length) {
                    //this.getServerList(true);
                    clearInterval(sessionStorage.instanceListInterval);
                    this.doPolling();
                    this.setState({ isMigration: false, migList: [] });
                }

                if(resp.length === 0) {
                    this.onCloneClose();
                    this.setState({ isMigration: false, migList: [] });
                }

            } else {
                this.onCloneClose();
                this.setState({ isMigration: false, migList: [] });
            }
        });
    }
    doCloneTimeout() {
        sessionStorage.cloneListInterval = setTimeout(() => this.getCloneList(), 20000);
    }
    doMigTimeout() {
        sessionStorage.migListInterval = setTimeout(() => this.getMigrationList(), 20000);
    }
    doInstanceCloneTimeout() {
        sessionStorage.cloneInstTimeout = setTimeout(() => {
            let items = this.state.servers.filter(item => item.status.toLowerCase() === 'build');
            if(items.length > 0) {
                clearTimeout(sessionStorage.cloneInstTimeout);
                this.getServerList(true);
                this.doInstanceCloneTimeout();
            }
        }, 10000);
    }
    doInstanceMigTimeout() {
        sessionStorage.migInstTimeout = setTimeout(() => {
            let items = this.state.servers.filter(item => item.status.toLowerCase() === 'build');
            if(items.length > 0) {
                clearTimeout(sessionStorage.migInstTimeout);
                this.getServerList(true);
                this.doInstanceMigTimeout();
            }
        }, 10000);
    }
    getInstanceItem(id, url, status) {
        let geturl = window.location.href;
        if(geturl.indexOf("index") === -1) {
            return;
        }
        if(status === 'DELETE') {
            let instances = this.state.servers.filter(item => item.id !== id);
            let filtList = this.getAllFilteredData(instances);
            this.setJsonPackData('serverlist' + this.state.userId, filtList);
            this.setState({ filteredData: filtList, servers: instances });
            return;
        }
        instanceService.getServerDetailsById(url, id).then(resp => {

            if(resp && resp.id) {
                if(resp.status !== status) {
                    sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(id, url, status), 10000);
                }
                let serverList = this.state.servers;
                if(serverList !== undefined && serverList.length > 0) {
                    let index = serverList.findIndex(item => item.id === id);
                    let elem = serverList[index];
                    let regionName = elem.region;
                    let fullRegion = elem.fullRegion;
                    elem = resp;
                    elem.region = regionName;
                    elem.fullRegion = fullRegion;
                    this.setProgressBar([elem]);
                    serverList[index] = elem;
                    let newFilteredData = this.getAllFilteredData(serverList);

                    this.setJsonPackData('serverlist' + this.state.userId, newFilteredData);

                    this.setState({ filteredData: newFilteredData });
                }
            }
        });
    }

    getAllFilteredData(data) {
        let newFilteredData = this.getStatusBasedData(data, this.state.dropDownStatus);
        newFilteredData = this.globalSearch(newFilteredData, this.state.searchInput);
        newFilteredData = this.getDefaultSortableData(this.state.sortColumn, newFilteredData);
        return newFilteredData;
    }

    setFlavorDetails() {

        FlavorService.getAllBmFlavors().then(resp => {
            if(resp && Array.isArray(resp) && resp.length > 0) {
                this.setState({
                    bmListFlav: resp
                });
                localStorage.setItem('BMflavors', JSON.stringify(resp));
            }
        });
        FlavorService.getAllRegionFlavors().then(resp => {
            if(resp && Array.isArray(resp) && resp.length > 0) {
                this.setState({ flavorList: resp });
                localStorage.setItem('flavorList', JSON.stringify(resp));
                //this.getServerList()
                this.checkForSubscription();
            }
        });
        FlavorService.getAllRegionFlavorsDb().then(resp => {
            if(resp && Array.isArray(resp) && resp.length > 0) {
                localStorage.setItem('flavorListDb', JSON.stringify(resp));
            }
        });

    }
    getFlavorDetailsById(flavorId) {
        try {
            let flavorList = this.state.flavorList;
            let BmList = JSON.parse(localStorage.getItem('BMflavors'));
            if(flavorList === undefined) {
                flavorList = JSON.parse(localStorage.getItem('flavorList'));
            }
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');
                let details = nameArr[1].toString().split('/');
                let type = 'Shared CPU';
                let processorType = 'vCPU, ';
                if(nameArr[0].includes('DCPU')) {
                    type = 'Dedicated CPU';
                    processorType = 'CPU, ';
                }
                let ram = details[0];
                let processor = flavorObj.vcpus;
                let storage = details[2];
                if(nameArr[0].includes('BM')) {

                    type = 'Bare Metal';

                    let bmObj = undefined;
                    try {
                        bmObj = BmList.find(item => item.id === flavorId);
                    }

                    catch(err) {
                        return '';
                    }

                    if(bmObj === undefined) {
                        return '';
                    }
                    processor = bmObj.processor + ", ";
                    processorType = bmObj.cpus + ', ';
                    ram = bmObj.ram;
                    storage = bmObj.storage;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return type + ', ' + processor + processorType + ram + ' RAM, ' + storage + ' NVMe storage';
            }
        } catch(e) {
            console.log(e);
        }
        return '';
    }

    getConsole = (flavorId) => {
        try {
            let flavorList = this.state.flavorList;
            let BmList = JSON.parse(localStorage.getItem('BMflavors'));
            if(flavorList === undefined) {
                flavorList = JSON.parse(localStorage.getItem('flavorList'));
            }
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');

                if(nameArr[0].includes('DCPU')) {
                    return true;
                }
                if(nameArr[0].includes('DCPU')) {
                    return true;
                }
                if(nameArr[0].includes('BM')) {
                    return false;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return true;
            }
        } catch(e) {
            console.log(e);
        }
        return '';
    };

    setRegionListByType(type) {
        // let localItem = JSON.parse(localStorage.getItem(type));
        // if(localItem!==undefined && localItem!==null){
        //     return
        // }
        instanceService.getRegionListByType(type).then(resp => {
            if(resp && Array.isArray(resp) && resp.length > 0) {
                localStorage.setItem(type, JSON.stringify(resp));
            }
        });
    }

    getFlavorOb(flavorId) {
        try {
            let flavorList = this.state.flavorList;
            if(flavorList === undefined) {
                flavorList = JSON.parse(localStorage.getItem('flavorList'));
            }
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');
                let details = nameArr[1].toString().split('/');
                let type = 'Shared CPU';
                let processorType = 'vCPU, ';
                if(!nameArr[0].includes('SCPU')) {
                    type = 'Dedicated CPU';
                    processorType = 'CPU, ';
                }
                let ram = details[0];
                let processor = flavorObj.vcpus;
                let storage = details[2];
                return {
                    type: type,
                    processor: processor,
                    processorType: processorType,
                    ram: ram,
                    storage: storage
                };
            }
        } catch(e) { }

        return '';
    }

    getServerList(isCached) {
        try {
            instanceService.getServerList(isCached).then(data => {
                if(!Array.isArray(data) || (data && data.message)) {
                    this.setState({ message: data.message, isAction: false, msgType: 'error' });
                    clearInterval(sessionStorage.instanceListInterval);
                    return;
                }

                this.setJsonPackData('serverlist' + this.state.userId, data);

                let data1 = this.setProgressBar([...data]);
                let newFilteredData = this.getStatusBasedData(data1, this.state.dropDownStatus);
                newFilteredData = this.globalSearch(newFilteredData, this.state.searchInput);
                newFilteredData = this.getDefaultSortableData(this.state.sortColumn, newFilteredData);

                newFilteredData = this.setNewStatus(newFilteredData);
                this.setState({ filteredData: newFilteredData, servers: data, isAction: false, indexCount: 0 }, () => this.activateActionMenu());
            });
        } catch(e) {
            console.log(e);
        }
    }
    setJsonPackData(type, data) {
        var packed = jsonpack.pack(data);
        //console.log('packed length ' + packed.length);
        localStorage.setItem(type, JSON.stringify(packed));
    }

    getJsonPackInstData() {
        // And then unpack the packed
        if(this.props.location.state && this.props.location.state.val) {
            return;
        }
        try {
            var serverlist = JSON.parse(localStorage.getItem('serverlist' + this.state.userId));
            if(serverlist === null) return;
            var json = jsonpack.unpack(serverlist);
            //console.log('unpacked length ' + JSON.stringify(json).length);
            let data1 = this.setProgressBar([...json]);
            let newFilteredData = this.getAllFilteredData(data1);

            newFilteredData = this.setNewStatus(newFilteredData);
            this.setState({ filteredData: newFilteredData, servers: json, isAction: false, indexCount: 0 }, () => this.activateActionMenu());
        } catch(err) {
            //
        }
    }

    setNewStatus = (newFilteredData) => {
        newFilteredData.forEach(server => {
            if(server.taskState === 'powering-on' || server.taskState === 'unrescuing')
                server.status = 'ACTIVE';
        });
        return newFilteredData;
    };

    activateActionMenu() {
        if(sessionStorage.isInstanceLoaded === "true") {
            return;
        }
        sessionStorage.isInstanceLoaded = "true";
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {
            $('.tabular_data_wrap .table_data .tr').removeClass('active');
            $(this).closest('.tr').addClass('active');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('active');
            $(this).find('.dropdown_component').css({ top: '30px' });
            var fmi = 'row_setting_dropdown';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');
            }
            else if(documentwindowHeight > totalHeight) {
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }
        });
    }

    getRegionUrl(region, type) {
        let computeRegions = JSON.parse(localStorage.getItem(type));
        let computeRegion = computeRegions.find(elem => elem.region === region);
        return computeRegion.url;
    }
    rowMenuClick = (event, server) => {
        if(server.status.toLowerCase() === 'suspended') {
            return;
        } else {
            let id = server.id;
            let region = server.region;
            let name = server.name;
            let flavorId = server.flavor.id;
            if(server.isSrcInst) {
                let items = [...this.state.servers];
                let filtItm = items.filter(item => item.metadata?.srcInst === server.id);
                filtItm[0].computeRegionUrl = this.getRegionUrl(filtItm[0].region, 'compute');
                if(filtItm.length > 0) {
                    this.setState({ migServer: filtItm[0] });
                }
            }
            this.setState({ computeRegionUrl: this.getRegionUrl(region, 'compute'), imageRegionUrl: this.getRegionUrl(region, 'image'), selectedInstanceId: id, selectedInstanceName: name, selectedFlavorId: flavorId, selectedInstance: server });
            //this.viewMoreList(event);
            $(event.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        }
    };

    viewMoreList(event) {
        try {
            let list = $(event.currentTarget).closest('.tr').find('ul')[0].children;
            var count = 0;
            for(var i = 0; i < list.length; i++) {
                if(list[i].nodeName === 'LI' && window.getComputedStyle(list[i]).display !== 'none') {
                    count++;
                }
            }
            if(count > 5) {
                $(event.currentTarget).closest('.tr').find('.row_setting_dropdown').addClass('viewMorelist');
            } else {
                $(event.currentTarget).closest('.tr').find('.row_setting_dropdown').removeClass('viewMorelist');
            }
        } catch(err) {
            console.log(err);
        }
    }

    getUndefinedItems(id, status) {
        let filterdData = this.state.filteredData;
        if(filterdData !== undefined && filterdData.length > 0) {
            let elem = filterdData.find(item => item.id === id);
            if(elem !== undefined) {
                elem.isProgess = true;
                elem.status = status;
                localStorage.removeItem('serverlist' + this.state.userId);
                return filterdData;
            }
        }
        return [];
    }
    rebootClick = (event) => {
        const i18n = this.props.i18n;
        let instance = this.state.selectedInstance;
        this.onRebootClose();
        this.setState({ isAction: true });
        let rebootType = 'SOFT';
        if(instance.status.toLowerCase() != 'active') {
            rebootType = 'HARD';
        }
        let computeRegionUrl = this.state.computeRegionUrl;
        let selectedInstanceId = this.state.selectedInstanceId;
        instanceService.rebootServer(selectedInstanceId, computeRegionUrl, rebootType).then(resp => {
            if(resp || resp === "") {
                let list = this.getUndefinedItems(selectedInstanceId, 'Reboot');
                this.setState({ isAction: false, filteredData: list, message: i18n.t('inst_reboot_success').replace('name', this.state.selectedInstanceName), msgType: '' });
                const requestBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.state.selectedInstanceName + " reboot successfull",
                    "operation": "Instance Reboot",
                    "region": this.state.selectedInstance.region
                };
                AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                    if(resp === false);
                });
                sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(selectedInstanceId, computeRegionUrl, 'ACTIVE'), 10000);
                return;
            }
            this.setState({ isAction: false, message: i18n.t('inst_action_failure').replace('action', 'reboot'), msgType: 'error' });
        });
    };
    powerOffClick = (event) => {
        const i18n = this.props.i18n;
        this.onPowerofClose();
        this.setState({ isAction: true });
        let selectedInstanceId = this.state.selectedInstanceId;
        let computeRegionUrl = this.state.computeRegionUrl;
        instanceService.stopServer(selectedInstanceId, computeRegionUrl).then(resp => {
            if(resp || resp === "") {
                let list = this.getUndefinedItems(selectedInstanceId, 'Power off');
                this.setState({ isAction: false, message: i18n.t('inst_shutoff_success').replace('name', this.state.selectedInstanceName), msgType: '', filteredData: list });
                sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(selectedInstanceId, computeRegionUrl, 'SHUTOFF'), 10000);
                return;
            }
            this.setState({ isAction: false, message: i18n.t('inst_action_failure').replace('action', 'shut-off'), msgType: 'error' });
        });
    };
    startClick = (event) => {
        const i18n = this.props.i18n;
        this.onStartClose();
        this.setState({ isAction: true });
        let selectedInstanceId = this.state.selectedInstanceId;
        let computeRegionUrl = this.state.computeRegionUrl;
        instanceService.startServer(selectedInstanceId, computeRegionUrl).then(resp => {
            if(resp || resp === "") {
                let list = this.getUndefinedItems(selectedInstanceId, 'Start');
                this.setState({ isAction: false, message: i18n.t('inst_start_success').replace('name', this.state.selectedInstanceName), msgType: '', filteredData: list });
                sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(selectedInstanceId, computeRegionUrl, 'ACTIVE'), 10000);
                return;
            }
            this.setState({ isAction: false, message: i18n.t('inst_action_failure').replace('action', 'start'), msgType: 'error' });
        });
    };

    launchConsoleClick = (event, flavourId) => {
        const i18n = this.props.i18n;
        //this.setState({ isAction: true });
        $(event.target.parentElement).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        // this.setState({ message: 'launching console', msgType: 'success'});
        //this.setState({ message: i18n.t('cons_open_process'), msgType: 'success' });
        //window.open(instanceService.getlcUrl(this.state.selectedInstanceId, this.state.computeRegionUrl));
        let type = "cloud";
        if(!this.getConsole(flavourId)) {
            // window.open(instanceService.getlcUrl(this.state.selectedInstanceId, this.state.selectedInstanceName,this.state.computeRegionUrl,"baremetal"),'_blank',"location=yes,height=600,width=1200,left = "+(window.screen.width-1200)/2+",top ="+(window.screen.height-600)/4+",scrollbars=yes,status=yes");
            type = "baremetal";
        }
        // else{
        // let url = API_HOST + `/server/console/` + this.state.selectedInstanceId + "/" + localStorage.getItem("userId") + '?region=' + this.state.computeRegionUrl + '&name=' + this.state.selectedInstanceName + '&type=' + type;
        // window.open(url, '_blank', "location=yes,height=600,width=1200,left = " + (window.screen.width - 1200) / 2 + ",top =" + (window.screen.height - 600) / 4 + ",scrollbars=yes,status=yes");
        // }
        var printWindow = window.open("", "", "location=yes,height=600,width=1000,left = " + (window.screen.width - 1000) / 2 + ",top =" + (window.screen.height - 600) / 4 + ",scrollbars=yes,status=yes");
        printWindow.document.write('<html><head><title></title>');
        printWindow.document.write('<style type = "text/css">');
        printWindow.document.write('.loader {top:40%;left:40%;transform: translate(-50%, -50%);position: fixed;border: 8px solid #f3f3f3; border-radius: 50%;border-top: 8px solid #3498db; width: 80px; height: 80px;-webkit-animation: spin 2s linear infinite; animation: spin 2s linear infinite;}');
        printWindow.document.write('@-webkit-keyframes spin {0% { -webkit-transform: rotate(0deg); }100% { -webkit-transform: rotate(360deg); }}');
        printWindow.document.write('@keyframes spin {0% { transform: rotate(0deg); }100% {transform: rotate(360deg); }}');
        printWindow.document.write('</style>');
        printWindow.document.write('</head><body ><div class=loader></div>');
        printWindow.document.write('</body></html>');
        instanceService.getlcUrl_v2(this.state.selectedInstanceId, this.state.selectedInstanceName, this.state.computeRegionUrl, type).then((resp) => {

            if(resp) {

                printWindow.location.href = resp;
                printWindow.focus();
            }
            else {
                printWindow.location.href = "/app/console-error";
                return;
            }
        }).catch(err => {
            printWindow.location.href = "/app/console-error";
            return;
        });

        // instanceService.launchConsole(this.state.selectedInstanceId, this.state.computeRegionUrl).then(resp => {
        //     this.setState({ isAction: false });
        //     if (resp.url) {
        //         let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        //         let messg = i18n.t('inst_launch_success').replace('name',this.state.selectedInstanceName)
        //         if(isSafari){
        //           messg= 'Launching console. If not launched please unblock the pop-up windows from the browser settings and try again.'  
        //         }
        //         this.setState({ message: messg, msgType: 'success' });
        //         window.open(resp.url);
        //         return;
        //     }
        //     this.setState({ message: i18n.t('inst_action_failure').replace('action','launch of console'), msgType: 'error' });
        // });
    };
    enableBackupClick = (event, instance) => {
        this.moveToPage("/server/backups", this.state.selectedInstanceId, this.state.computeRegionUrl, this.state.imageRegionUrl, instance);
    };
    settingsClick = (event, instance) => {
        this.moveToPage("/server/settings", this.state.selectedInstanceId, this.state.computeRegionUrl, this.state.imageRegionUrl, instance);
    };
    resizeClick = (event, instance) => {
        this.moveToPage("/server/resize", this.state.selectedInstanceId, this.state.computeRegionUrl, this.state.imageRegionUrl, instance);
    };
    rebuildClick = (event, instance) => {
        this.goToRebuildPage("/server/rebuild", this.state.selectedInstanceId, this.state.computeRegionUrl, this.state.imageRegionUrl, instance);
    };

    cloneClick = (event, instance) => {
        if(localStorage.getItem("status") === 'S' || this.state.isCreateExternalDisabled) return;
        let flavors = this.getFlavorOb(instance.flavor.id);
        this.props.history.push({
            pathname: "/instance-clone",
            state: {
                instance: instance,
                flavors: flavors
            }
        });
    };

    goToRebuildPage(pageUrl, instanceId, computeRegionUrl, imageRegionUrl, instance) {
        let server = {};
        server.id = instanceId;
        server.computeRegionUrl = computeRegionUrl;
        server.imageRegionUrl = imageRegionUrl;
        server.instance = instance;
        server.regionName = instance.region;
        sessionStorage.server = JSON.stringify(server);
        this.props.history.push(pageUrl);
    }

    moveToPage(pageUrl, instanceId, computeRegionUrl, imageRegionUrl, instance) {
        if((instance.status.toLowerCase() === 'active' || instance.status.toLowerCase() === 'shutoff') && instance.isProgess === undefined) {
            let server = {};
            server.id = instanceId;
            server.computeRegionUrl = computeRegionUrl;
            server.imageRegionUrl = imageRegionUrl;
            server.instance = instance;
            server.regionName = instance.region;
            sessionStorage.server = JSON.stringify(server);
            sessionStorage.migServer = undefined;
            try {
                if(instance.isSrcInst) {
                    sessionStorage.migServer = JSON.stringify(this.getMigServer(instance));
                }
            } catch(err) {
                console.log(err);
            }
            this.props.history.push(pageUrl);
        }
    }


    deleteBareMetalInstance = (i18n, serverId, region) => {
        instanceService.deleteBMServer(serverId, region).then(resp => {
            if(resp) {
                let list = this.getUndefinedItems(serverId, 'Delete');
                const requestBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.state.selectedInstanceName + " has been deleted",
                    "operation": "Instance Deleted",
                    "region": this.state.selectedInstance.region
                };
                AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({ isAction: false, message: i18n.t('inst_delete_success').replace('name', this.state.selectedInstanceName), msgType: '', filteredData: list });
                sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(serverId, region, 'DELETE'), 10000);
                return;
            }
            this.setState({ isAction: false, message: i18n.t('inst_action_failure').replace('action', 'delete'), msgType: 'error' });
        });
    };

    deleteClick = (event) => {
        const i18n = this.props.i18n;
        this.onDeleteClose();
        this.setState({ isAction: true });
        let selectedInstanceId = this.state.selectedInstanceId;
        if(!selectedInstanceId) selectedInstanceId = this.state.selectedInstance.id;
        let computeRegionUrl = this.state.computeRegionUrl;
        if(this.state.currentFlavType == "Bare Metal") {
            this.deleteBareMetalInstance(i18n, selectedInstanceId, this.state.selectedInstance.region);
            return;
        }
        instanceService.deleteServer(selectedInstanceId, computeRegionUrl, this.state.selectedInstance.region, this.state.selectedInstance.mainIpAddress).then(resp => {
            if(resp === 204) {
                let list = this.getUndefinedItems(selectedInstanceId, 'Delete');
                const requestBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.state.selectedInstanceName + " has been deleted",
                    "operation": "Instance Deleted",
                    "region": this.state.selectedInstance.region
                };
                AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({ isAction: false, message: i18n.t('inst_delete_success').replace('name', this.state.selectedInstanceName), msgType: '', filteredData: list });
                sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(selectedInstanceId, computeRegionUrl, 'DELETE'), 10000);
                return;
            }
            this.setState({ isAction: false, message: 'Failed to delete the instance ' + this.state.selectedInstanceName + '. Contact <a href="https://www.idrivecompute.com/support.htm" target="_blank">support</a> for further assistance.', msgType: 'error' });
        });
    };

    goToSummary = (event, server, param) => {
        let computeRegionUrl = this.getRegionUrl(server.region, 'compute');
        let imageRegionUrl = this.getRegionUrl(server.region, 'image');
        if(param) {
            this.moveToPage("/server/summary", server.id, computeRegionUrl, imageRegionUrl, server);//for narmal change network to summary here
        }
        else {
            this.moveToPage("/server/networking", server.id, computeRegionUrl, imageRegionUrl, server);
        }

    };

    setProgressBar(data) {
        if(data === undefined || data === null) {
            return;
        }
        let status = true;
        data.forEach(item => {
            if(item.flav === undefined) item.flav = this.getFlavorDetailsById(item.flavor.id);
            item.mainIpAddress = this.getMainIp(item.ipaddress, item.id);
            let isSrcInst = data.filter(elm => elm.metadata?.opType === 'migration' && elm.metadata?.srcInst === item.id && elm.status !== 'ERROR');
            if(isSrcInst.length > 0) item.isSrcInst = true;
            let itemStatus = item.status.toLowerCase();
            if(itemStatus === 'migrating' || item.taskState === 'migrating') {
                item.status = 'ACTIVE';
                item.taskState = null;
            } else if(itemStatus === 'shelved_offloaded') {
                item.status = 'SUSPENDED';
            }
            if((itemStatus === 'build' || item.taskState === "deleting" || item.taskState === 'rescuing' || itemStatus === 'resize' || itemStatus === 'reboot' || itemStatus === 'rebuild' || item.taskState !== null || itemStatus === 'unrescue') && itemStatus !== 'error') {
                status = false;
                item.isProgess = true;
                item.progressPerc = 60;
            } else if(itemStatus === 'verify_resize') {
                item.isProgess = true;
                this.confirmResize(item.id, item.region);
                status = false;
            } else {
                item.isProgess = undefined;
                item.progressPerc = 60;
            }
            item.showBanner = this.checkBanner(item.id, !item.isProgess, itemStatus, item.flavor.id, item.createdOn);
        });
        if(status) {
            clearInterval(sessionStorage.instanceListInterval);
        }
        return data;
    }

    progressAction = (server) => {
        let serverAction = server.status;
        if(serverAction === 'ACTIVE' || serverAction === 'SHUTOFF' || (server.status === 'RESCUE' && server.taskState === 'unrescuing'))
            serverAction = server.taskState;
        return getInstMessage(serverAction);
    };

    handleDropdown = (event, status, dropdown) => {
        let newFilteredData = [];
        newFilteredData = this.getStatusBasedData(this.state.servers, status);
        newFilteredData = this.globalSearch(newFilteredData, this.state.searchInput);
        newFilteredData = this.getDefaultSortableData(this.state.sortColumn, newFilteredData);
        this.setState({ filteredData: newFilteredData, dropDown: dropdown, dropDownStatus: status, indexCount: 0 });
        $('.bn_dropdown_ul').removeClass('active');
        event.stopPropagation();
    };

    getStatusBasedData = (data, status) => {
        if(status.includes('All Instances')) {
            return data;
        }
        return data.filter(server => {
            return (
                server.status.toLowerCase().includes(status.toLowerCase())
            );
        });
    };


    handleSearch = (event) => {
        if(event.key.trim() === '' || event.key === 'Enter') {
            return;
        }
        let searchInput = document.getElementById('searchbox').value;
        let newFilteredData = this.getDefaultSortableData(this.state.sortColumn, this.state.servers);
        newFilteredData = this.getStatusBasedData(newFilteredData, this.state.dropDownStatus);
        this.setState({ filteredData: this.globalSearch(newFilteredData, searchInput), searchInput: searchInput, indexCount: 0 });
    };


    globalSearch = (data, searchInput) => {
        if(searchInput === '') {
            return data;
        }
        return data.filter(server => {
            return (
                server.mainIpAddress.toString().toLowerCase().includes(searchInput.toLowerCase()) ||
                server.region.toLowerCase().includes(searchInput.toLowerCase()) ||
                server.status.toLowerCase().includes(searchInput.toLowerCase()) ||
                server.createdOn.toLowerCase().includes(searchInput.toLowerCase()) ||
                server.name.toLowerCase().includes(searchInput.toLowerCase())
            );
        });
    };
    setSortable = (param) => {
        let newFilteredData = this.state.servers;
        newFilteredData = this.globalSearch(newFilteredData, this.state.searchInput);
        newFilteredData = this.getStatusBasedData(newFilteredData, this.state.dropDownStatus);
        this.setState({ filteredData: this.getSortableData(param[0], newFilteredData), sortColumn: param[0], indexCount: 0 });
    };

    getSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        if(type === "name") {
            let nameOrder = '';
            if(this.state.nametoggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
                nameOrder = 'asc';
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
                nameOrder = 'desc';
            }
            this.setState({ nametoggle: !this.state.nametoggle, nameOrder: nameOrder });
            return items;
        }
        else if(type === "region") {
            let regionOrder = '';
            if(this.state.regiontoggle) {
                items.sort(function (a, b) {
                    if(a.region < b.region) { return -1; }
                    if(a.region > b.region) { return 1; }
                    return 0;
                });
                regionOrder = 'asc';
            }
            else {
                items.sort(function (a, b) {
                    if(a.region < b.region) { return 1; }
                    if(a.region > b.region) { return -1; }
                    return 0;
                });
                regionOrder = 'desc';
            }
            this.setState({ regiontoggle: !this.state.regiontoggle, regionOrder: regionOrder });
            return items;
        }
        else if(type === "date") {
            let dateOrder = '';
            if(this.state.datetoggle) {
                items.sort(function (a, b) {
                    return new Date(a.createdOn) - new Date(b.createdOn);
                });
                dateOrder = 'asc';
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.createdOn) - new Date(a.createdOn);
                });
                dateOrder = 'desc';
            }
            this.setState({ datetoggle: !this.state.datetoggle, dateOrder: dateOrder });
            return items;
        }
        else if(type === "status") {
            let statusOrder = '';
            if(this.state.statustoggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });
                statusOrder = 'asc';
            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });
                statusOrder = 'desc';
            }
            this.setState({ statustoggle: !this.state.statustoggle, statusOrder: statusOrder });
            return items;
        }
        return items;
    };

    getDefaultSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        if(type === "name") {
            if(this.state.nameOrder === 'asc') {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }

            return items;
        }
        else if(type === "region") {
            if(this.state.regionOrder === 'asc') {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return -1; }
                    if(a.fullRegion > b.fullRegion) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return 1; }
                    if(a.fullRegion > b.fullRegion) { return -1; }
                    return 0;
                });
            }

            return items;
        }
        else if(type === "date") {
            if(this.state.dateOrder === 'asc') {
                items.sort(function (a, b) {
                    return new Date(a.createdOn) - new Date(b.createdOn);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.createdOn) - new Date(a.createdOn);
                });
            }
            return items;
        }
        else if(type === "status") {
            if(this.state.statusOrder === 'asc') {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });
            }

            return items;
        }
        return items;
    };


    bnDropdownClick = (event) => {
        $('.bn_dropdown .bn_dropdown_ul').addClass('active');
    };
    btnCancelClick = (event) => {
        $(event.currentTarget).closest('.main_popup').removeClass('active');
    };
    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };
    onUnrescueClick(instance) {
        let i18n = this.props.i18n;
        this.onunrescueClose();
        this.setState({ isAction: true });
        let requestBody = {
            unrescue: null
        };
        let selectedInstanceId = this.state.selectedInstanceId;
        let computeRegionUrl = this.state.computeRegionUrl;
        instanceService.serverAction(selectedInstanceId, computeRegionUrl, requestBody).
            then(resp => {
                if(resp || resp === "") {
                    const requestBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Instance " + this.state.selectedInstanceName + " unrescued sucessfully",
                        "operation": "Instance Unrescued",
                        "region": this.state.selectedInstance.region
                    };
                    AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                        if(resp === false);
                    });
                    let list = this.getUndefinedItems(selectedInstanceId, 'Unrescue');
                    this.setState({ message: i18n.t('inst_unrescue_success').replace('name', this.state.selectedInstanceName), isAction: false, filterdData: list });
                    sessionStorage.itemInterval = setTimeout(() => this.getInstanceItem(selectedInstanceId, computeRegionUrl, 'ACTIVE'), 10000);
                    return;
                }
                this.setState({ message: i18n.t('inst_action_failure').replace('action', 'unrescue'), msgType: 'error', isAction: false });
            });
    }

    confirmResize(instanceId, region) {
        let confirmBody = {
            confirmResize: null
        };
        let computeUrl = this.getRegionUrl(region, 'compute');
        instanceService.serverActionResize_v2(instanceId, computeUrl, "confirmResize", confirmBody, "confirmResize", region).then(resp => console.log('done for verifyResize'));
    }

    nextPath(path) {
        this.props.history.push(path);
    }
    onRebootClick = (e) => {
        $(e.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $('#rebootPopup').addClass('active');
        $("body").addClass("popup_no_scroll");

        document.getElementById('rebootBtn').focus();
        e.stopPropagation();
    };
    onRebootClose = () => {
        $('#rebootPopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");

    };
    onPowerofClick = (e) => {
        $(e.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $('#poweroffPopup').addClass('active');
        $("body").addClass("popup_no_scroll");

        document.getElementById('poweroffBtn').focus();
        e.stopPropagation();
    };
    onPowerofClose = () => {
        $('#poweroffPopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    getMigServer(server) {
        if(server.isSrcInst) {
            let items = [...this.state.servers];
            let filtItm = items.filter(item => item.metadata?.srcInst === server.id);
            filtItm[0].computeRegionUrl = this.getRegionUrl(filtItm[0].region, 'compute');
            if(filtItm.length > 0) {
                return filtItm[0];
            }
        }
    }
    onDeleteClick = (e, flavor, status, fault, server) => {
        if(server.isSrcInst) {
            let items = [...this.state.servers];
            let filtItm = items.filter(item => item.metadata?.srcInst === server.id);
            if(filtItm.length > 0) {
                this.setState({ migServer: filtItm[0] });
            }
            $('#cnfmDelMig').addClass('active');
            $('#cnfmBtn').focus();
            return;
        }
        if(this.state.migList && this.state.migList.length > 0) {
            let a = this.state.migList.find(ite => ite.srcInstId === server.id);
            if(a) {
                this.setState({ message: 'The instance cannot be deleted as the migration is in progress', msgType: 'error' });
                return;
            }
        }
        let flav = this.getFlavorDetailsById(flavor);
        let data = flav.split(",");
        this.setState({
            currentFlavType: data[0],
            currentStatus: status,
            currentFault: fault,
        });
        $(e.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $('#deletePopup').addClass('active');
        $("body").addClass("popup_no_scroll");
        document.getElementById('deleteBtn').focus();
        e.stopPropagation();
    };

    onRetryClick = (e, instance) => {
        this.props.history.push({
            pathname: "/create",
            state: {
                instanceOb: { ...instance },
                regionName: instance.region
            }
        });
    };
    onDeleteClose = () => {
        $('#deletePopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    onStartClick = (e) => {
        $(e.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $('#startPoup').addClass('active');
        $("body").addClass("popup_no_scroll");

        document.getElementById('startBtn').focus();
        e.stopPropagation();
    };
    onStartClose = () => {
        $('#startPoup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };
    onUnrescueActionClick = (e) => {
        $(e.currentTarget).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $('#unrescuePopup').addClass('active');
        $("body").addClass("popup_no_scroll");

        document.getElementById('unrescueBtn').focus();
        e.stopPropagation();
    };
    onunrescueClose = () => {
        $('#unrescuePopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };

    onCloneClose = () => {
        $('#cloneDetailPopup').removeClass('active');
        $('#migDetailPopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    };

    clonePopupOpen = () => {
        $('.clone_accordWrap').removeClass('active');
        $('#cloneDetailPopup').addClass('active');
        $("body").addClass("popup_no_scroll");
    };

    migPopupOpen() {
        $('.migr_accordWrap').removeClass('active');
        $('#migDetailPopup').addClass('active');
        $("body").addClass("popup_no_scroll");
    }

    copyToclipboard = (event, text) => {
        this.setState({
            isCopied: true
        });
        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;
    };

    getAdditionalIpDetails = () => {

        NetworkService.getIPDetailsByUser().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false
                });
            }
            if(resp.data == "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: [],
                    additionalIPCount: 0
                });
            }
            if(resp.data != "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: resp.data,
                    additionalIPCount: resp.data.length
                });

            }


        })
            .catch(error => {
                this.setState({
                    isAction: false
                });
            });
    };
    getMainIp = (ipList, serverId) => {
        let compute = this.state.additionalIPs;
        if(compute?.length > 0) {
            let result = [];
            for(let i = 0; i < compute.length; i++) {
                if(compute[i].instance_id == serverId)
                    result.push(compute[i].ip_address);
            }
            var final = ipList.filter(function (obj) { return result.indexOf(obj) == -1; });
            return final[0];
        }
        else {
            return ipList[0];
        }

    };
    checkIp(ip, list) {
        let flag = true;
        for(let i = 0; i < list.length; i++) {
            if(ip == list[i]) {
                flag = false;
            }
        }
        if(flag) {
            return true;
        }
        else {
            return false;
        }
    }
    isSourceInstance(server) {
        if(!server.isSrcInst) {
            if(this.state.migList.length > 0) {
                let ob = this.state.migList.find(item => item.srcInstId === server.id);
                if(ob) {
                    return true;
                }
            }
        }

        return server.isSrcInst;
    }
    instMigration(event, server) {
        if(localStorage.getItem("status") === 'S' || this.state.isCreateExternalDisabled) return;
        if(this.state.migList.length > 0) {
            let ob = this.state.migList.find(item => item.srcInstId === server.id);
            if(ob) {
                $('.row_setting_dropdown ').removeClass('active');
                this.setState({ message: 'Instance migration is not possible at this moment. ', msgType: 'error' });
                return;
            }
        }
        $(event.target.parentElement).closest('.tr').find('.row_setting_dropdown').toggleClass('active');
        $("body").addClass("popup_no_scroll");
        $('.migrate_slider').addClass('active');
        //document.getElementById('migSlider').scrollIntoView();
        this.instMig.current.onInstanceMigrationSelection();
    }
    confirmMigration(event, server, isPopupReq) {
        event.preventDefault();
        if(server.status.toLowerCase() === 'suspended') return;
        let srcInstId = server.metadata?.srcInst;
        let servers = this.state.servers;
        let srcServer = servers.filter(item => item.id === srcInstId);
        if(isPopupReq) {
            $('.row_setting_dropdown').removeClass('active');
            $('#cnfmMig').addClass('active');
            $("body").addClass("popup_no_scroll");
            this.setState({ selectedInstance: server, srcServer: srcServer[0] });
            setTimeout(() => {
                $('#cnfmBtn1').focus();
            }, 50);
            event.stopPropagation();
            return;
        }
        $('#cnfmMig').removeClass('active');
        $('#cnfmDelMig').removeClass('active');
        $("body").removeClass("popup_no_scroll");
        let filteredData = this.state.filteredData;
        let srcElem = filteredData.find(item => item.id === srcInstId);
        if(srcElem !== undefined) {
            srcElem.isProgess = true;
            srcElem.status = 'Delete';
            server.isProgess = true;
            server.status = 'Migration confirmation';
        }
        this.setState({ isAction: true, filteredData: filteredData });

        instanceService.migration(server.id, this.getRegionUrl(server.region, 'compute'), this.getRegionUrl(srcServer[0].region, 'compute'), 'metadata').then(resp => {
            if(resp === 'success') {
                setTimeout(() => {
                    this.getServerList(true);
                    this.getBackUpInstances("onLoad");
                    this.setState({ message: 'Instance migration confirmed.', msgType: 'success', isAction: false });
                }, 5000);
            } else {
                this.setState({ message: 'Failed to confirm the migration.', msgType: 'error', isAction: false });

            }
        });
        event.stopPropagation();
    }
    revertMig(event, server) {
        event.preventDefault();
        if(server.status.toLowerCase() === 'suspended') return;
        this.setState({ selectedInstance: server, computeRegionUrl: this.getRegionUrl(server.region, 'compute') });
        $('.bn_dropdown_ul').removeClass('active');
        $("body").addClass("popup_no_scroll");
        $('#revertMig').addClass('active');
        setTimeout(() => {
            $('#revertCnf').focus();
        }, 50);


    }
    revertMigUpdate() {
        $('#revertMig').removeClass('active');
        $("body").removeClass("popup_no_scroll");
        this.setState({ isAction: true, msgType: '' });

        instanceService.instReject(this.state.selectedInstance.id, this.state.computeRegionUrl).then(resp => {
            if(resp && resp.id) {
                this.getServerList(true);
                setTimeout(() => {
                    this.getServerList(true);
                    this.setState({ message: 'Migration is reverted.', msgType: 'success', isAction: false });
                }, 6000);
            } else {
                this.setState({ message: 'Failed to revert the migration.', msgType: 'error', isAction: false });
            }
        });

    }
    migInfo(server) {
        let srcInstId = server.metadata?.srcInst;
        let servers = this.state.servers;
        let srcServer = servers.filter(item => item.id === srcInstId);
        this.setState({ selectedInstance: server, srcServer: srcServer[0] });
        $('#migInfo').addClass('active');
        $("body").addClass("popup_no_scroll");

        //event.stopPropagation();
    }
    checkBanner = (serverId, isProgress, serverStatus, flavourId, date) => {
        if(this.checkBackUpInstances(serverId) && isProgress && serverStatus == "active" && this.getConsole(flavourId) && this.checkDate(date) && localStorage.getItem("_banner_show") === "show" && localStorage.getItem("_cmplt_banner_show") === "show") {
            return true;
        }
        return false;
    };
    toggleArrow(event) {
        $(event.currentTarget.parentElement).toggleClass('active');
    }
    instReactElement = (server, i) => {
        let classData = '';
        let isMigrate = false; let isBackup = false;
        let isBmr = this.getConsole(server.flavor.id);
        let isSuspended = localStorage.getItem("status") === 'S';
        let isSrcInstance = this.isSourceInstance(server);
        if(server.status.toLowerCase() !== 'error' && !server.isProgess && server.metadata?.opType === 'migration') {
            classData = 'instance_migrate';
            isMigrate = true;
        } else if(server.showBanner && !server.isProgess) {
            classData = 'instance_backup';
            isBackup = true;
        }
        return (
            <li
                className={ classData + " tr " + server.status.toLowerCase() } key={ i }>

                <div className="table_col_wrap expand">
                    <div className="col col1" style={ { cursor: 'pointer' } } onClick={ (e) => this.goToSummary(e, server, isBmr) }>
                        <div className="server_icon">
                            <div className="icon_img">
                                <span className="icon">
                                    <svg x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" style={ { enableBackground: 'new 0 0 100 100' } } xmlSpace="preserve">
                                        <path fill="#FFFFFF" d="M73.6,26.7c0,0,4.8,3.5,1.8,9.4l-2.8,5.3l-16.4-9.3c0,0-2.8-1.4-5.4,0.1l-13,7c0,0-2.3,0.8-2.3,2.9v14.5
		                                                                                    c0,0-0.6,2.4,1.6,3.5l14,8.3c0,0,2.6,1.6,5.5-0.2l15.2-9.8l2.8,3.7c0,0,4.5,6-1.1,10.8l-16,9.9c0,0-3,2.2-7.2-0.2L26.6,69.1
		                                                                                    c0,0-3.5-1.3-3-5.8V36.1c0,0-0.5-3,2-5l23.8-13.5c0,0,4.1-2.4,7-0.7L73.6,26.7z"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div className="server_content">
                            <div className="sys_os" data-tip={ server.name }>{ server.name }
                                <ReactToolTip place="top" effect="solid" />
                            </div>
                            <div className="sys_config">{ server.flav }</div>
                        </div>
                    </div>

                    <div className="col col2">
                        <div className="ip_address_show">{ server.mainIpAddress }</div>
                        <div className="ip_address_copy" style={ { display: server.ipaddress.length > 0 && server.mainIpAddress !== 'NA' ? '' : 'none' } }>
                            <span className="svg_wrap" data-tip data-for="copy" onClick={ (e) => this.copyToclipboard(e, server.mainIpAddress) } onMouseLeave={ () => this.setState({ isCopied: false }) } >
                                <svg x="0px" y="0px" width="14px" height="16.5px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                </svg></span><ReactToolTip id="copy" place="right" effect="solid">{ this.state.isCopied ? "Copied" : "Copy" }</ReactToolTip>
                        </div>
                    </div>
                    <div className="col col3">{ server.fullRegion }</div>
                    <div className="col col4">
                        <span className={ "server_status " + (server.status.toLowerCase()) }>{ server.status }</span>
                    </div>
                    <div className="col col5">
                        { server.createdOn }
                    </div>
                    <div className={ server.status.toLowerCase() === "suspended" ? "col col6 disabled" : "col col6" }>
                        <span className="row_menu_icon" onClick={ (e) => this.rowMenuClick(e, server) }>
                            <svg
                                className="horizMenuIcon"
                                x="0px"
                                y="0px"
                                viewBox="0 0 22.1 6.3"
                                enableBackground="new 0 0 22.1 6.3"
                                xmlSpace="preserve"
                                data-tip data-for="actions">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    fill="#8692B0"
                                    d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                            </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip>
                            <ul className="dropdown_component row_setting_dropdown">
                                <span className="arrow_pointer"></span>
                                { server.metadata?.opType !== 'migration' && <li className="reboot" style={ { display: server.status.toLowerCase() !== 'rescue' && server.status.toLowerCase() !== 'unrescue' && server.status.toLowerCase() !== 'error' && server.status.toLowerCase() !== 'shutoff' ? 'block' : 'none' } }
                                    onClick={ (e) => this.onRebootClick(e) }>
                                    <span className="icon">
                                        <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 18 18"
                                            enableBackground="new 0 0 18 18"
                                            xmlSpace="preserve">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                fill="#4C8CCD"
                                                d="M9,17.5c-4.5,0-8.2-3.5-8.5-8h2c0.3,3.4,3,6,6.5,6  c3.6,0,6.5-2.9,6.5-6.5S12.6,2.5,9,2.5C7.4,2.5,6,3.1,4.9,4l2.5,2.5h-6v-6l2,2c1.5-1.3,3.4-2,5.5-2c4.7,0,8.5,3.8,8.5,8.5  S13.7,17.5,9,17.5z"></path>
                                        </svg>
                                    </span>Reboot</li> }

                                { server.metadata?.opType !== 'migration' && <li className="power_off" style={ { display: server.status.toLowerCase() === 'active' ? 'block' : 'none' } }
                                    onClick={ (e) => this.onPowerofClick(e) }>
                                    <span className="icon">
                                        <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 18 18"
                                            enableBackground="new 0 0 18 18"
                                            xmlSpace="preserve">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                fill="#4C8CCD"
                                                d="M9.2,17.8c-4.3,0-7.9-3.5-7.9-7.9c0-3.3,2-6.1,4.9-7.3v2.1  c-1.8,1-3.1,3-3.1,5.2c0,3.3,2.7,6,6,6s6-2.7,6-6c0-2.2-1.2-4.2-3.1-5.2v-2c2.9,1.2,4.9,4,4.9,7.3C17.1,14.3,13.5,17.8,9.2,17.8z   M9.2,9c-0.5,0-1-0.4-1-1V1.1c0-0.5,0.4-1,1-1s1,0.4,1,1V8C10.2,8.5,9.7,9,9.2,9z"></path>
                                        </svg>
                                    </span>Power Off</li> }

                                { server.metadata?.opType !== 'migration' && <li className="restart" style={ { display: server.status.toLowerCase() === 'shutoff' ? 'block' : 'none' } }
                                    onClick={ (e) => this.onStartClick(e) }>
                                    <span className="icon">
                                        <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 18 18"
                                            enableBackground="new 0 0 18 18"
                                            xmlSpace="preserve">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                fill="#4C8CCD"
                                                d="M9,17.5c-4.5,0-8.2-3.5-8.5-8h2c0.3,3.4,3,6,6.5,6  c3.6,0,6.5-2.9,6.5-6.5S12.6,2.5,9,2.5C7.4,2.5,6,3.1,4.9,4l2.5,2.5h-6v-6l2,2c1.5-1.3,3.4-2,5.5-2c4.7,0,8.5,3.8,8.5,8.5  S13.7,17.5,9,17.5z"></path>
                                        </svg>
                                    </span>Start</li> }

                                { server.metadata?.instType !== 'rancher' && <li className="restart" onClick={ (e) => { this.launchConsoleClick(e, server.flavor.id); e.stopPropagation(); } }
                                    style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'rescue')) ? 'block' : 'none' } }>
                                    <span className="icon">
                                        <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 18 18"
                                            enableBackground="new 0 0 18 18"
                                            xmlSpace="preserve">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                fill="#4C8CCD"
                                                d="M15.4,14.4h-13c-1.1,0-2-0.9-2-2v-10c0-1.1,0.9-2,2-2h13  c1.1,0,2,0.9,2,2v10C17.4,13.5,16.5,14.4,15.4,14.4z M15.4,2.4h-13v10h13V2.4z M4.9,3.4l3.5,3.5L7.7,7.6l-2.8,2.8L3.4,9l2.1-2.1  L3.4,4.8L4.9,3.4z M14.4,8.4h-5v-2h5V8.4z M13.4,17.4h-9v-2h9V17.4z"></path>
                                        </svg>
                                    </span>Launch Console</li> }


                                { server.metadata?.opType !== 'migration' && !server.isSrcInst && <li className="resize" onClick={ (e) => { this.resizeClick(e, server); e.stopPropagation(); } }
                                    style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff') && isBmr) ? 'block' : 'none' } }>
                                    <span className="icon">
                                        <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 18 18"
                                            enableBackground="new 0 0 18 18"
                                            xmlSpace="preserve">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                fill="#4C8CCD"
                                                d="M15.5,16.5L15.5,16.5h-4.3c-0.6,0-1-0.4-1-1v-0.1c0-0.6,0.4-1,1-1  h1.7l-3.1-3.1c0.7-0.3,1.2-0.8,1.5-1.5l3.1,3.1v-1.7c0-0.6,0.4-1,1-1h0.1c0.6,0,1,0.4,1,1v4.2v0.1C16.5,16.1,16.1,16.5,15.5,16.5z   M15.5,7.8L15.5,7.8c-0.6,0-1.1-0.4-1.1-1V5.1l-3.1,3.1c-0.3-0.7-0.8-1.2-1.5-1.5l3.1-3.1h-1.7c-0.6,0-1-0.4-1-1V2.5  c0-0.6,0.4-1,1-1h4.2h0.1c0.6,0,1,0.4,1,1v0.1v4.2C16.5,7.3,16.1,7.8,15.5,7.8z M6.5,3.5H4.9l3.2,3.2C7.4,6.9,6.9,7.4,6.7,8.1  L3.5,4.9v1.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-4c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1S7.1,3.5,6.5,3.5z M2.5,10.5c0.6,0,1,0.4,1,1v1.6  l3.2-3.2c0.3,0.6,0.8,1.2,1.4,1.4l-3.2,3.2h1.6c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1v-4C1.5,10.9,1.9,10.5,2.5,10.5z"></path>
                                        </svg>
                                    </span>Resize</li> }
                                { server.metadata?.opType !== 'migration' && !server.isSrcInst && !isSrcInstance && <li className={ isSuspended || this.state.isCreateExternalDisabled ? "clone disabled" : "clone" } onClick={ (e) => { this.cloneClick(e, server); e.stopPropagation(); } }
                                    data-for="cloneSuspended" data-tip
                                    style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff') && isBmr) ? 'block' : 'none' } }>
                                    <span className="icon">
                                        <svg x="0px" y="0px" width="17.9px" height="17.6px" viewBox="0 0 17.9 17.6" enableBackground="new 0 0 17.9 17.6" xmlSpace="preserve">

                                            <path d="M15.5,17.3h-8c-1.1,0-2-0.9-2-2v-8c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v8C17.5,16.4,16.6,17.3,15.5,17.3z
                                                                                            M15.5,8.3c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V8.3z M10.5,3.3c0-0.6-0.4-1-1-1h-6
                                                                                            c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h1v2h-2c-1.1,0-2-0.9-2-2v-8c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v2h-2V3.3z"
                                                fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD"></path>
                                        </svg>
                                    </span>Clone</li> }
                                <div style={ { display: isSuspended ? "" : "none" } }>
                                    <ReactToolTip id='cloneSuspended' place='left' effect='solid'>Account Suspended. Insufficient privileges to perform clone operation.</ReactToolTip>
                                </div>

                                { server.metadata?.opType !== 'migration' && <li className="enable_bckup" onClick={ (e) => { this.enableBackupClick(e, server); e.stopPropagation(); } }
                                    style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff') && isBmr) ? 'block' : 'none' } }>
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M11.4,14.7h-5c-3.3,0-6-2.7-6-6s2.7-6,6-6h5c3.3,0,6,2.7,6,6  S14.8,14.7,11.4,14.7z M11.4,4.7h-5c-2.2,0-4,1.8-4,4s1.8,4,4,4h5c2.2,0,4-1.8,4-4S13.7,4.7,11.4,4.7z M11.4,11.7c-1.7,0-3-1.3-3-3  s1.3-3,3-3s3,1.3,3,3S13.1,11.7,11.4,11.7z"></path>
                                        </svg>
                                    </span>Configure Backup</li> }
                                { server.metadata?.opType !== 'migration' && !server.isSrcInst && !isSrcInstance && <li className={ isSuspended || this.state.isCreateExternalDisabled ? "migrate disabled" : "migrate" } data-for="migSuspended" data-tip style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff') && isBmr) ? '' : 'none' } } onClick={ (e) => { this.instMigration(e, server); e.stopPropagation(); } }>
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 20.9 20" style={ { enableBackground: 'new 0 0 20.9 20' } } xmlSpace="preserve">
                                            <polyline className="rmi0" points="11.1,10.3 6.3,10.3 6.3,13.4 1.1,8.4 6.3,3.3 6.3,6.4 12,6.4 "></polyline>
                                            <polyline className="rmi0" points="9.8,10.3 14.6,10.3 14.6,7.1 19.8,12.2 14.6,17.3 14.6,14.1 8.9,14.1 "></polyline>
                                        </svg>
                                    </span>
                                    Migrate
                                </li> }
                                <div style={ { display: isSuspended ? "" : "none" } }>
                                    <ReactToolTip id='migSuspended' place='left' effect='solid'>Account Suspended. Insufficient privileges to perform migrate operation.</ReactToolTip>
                                </div>

                                { server.metadata?.opType !== 'migration' && <li className="settings" onClick={ (e) => { this.settingsClick(e, server); e.stopPropagation(); } }
                                    style={ { display: server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff' ? 'block' : 'none' } }>
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                            <g>
                                                <path fill="#4C8CCD" d="M9.3,12.9c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S11.2,12.9,9.3,12.9z M9.3,7.6   c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C11,8.4,10.2,7.6,9.3,7.6z"></path>
                                            </g>
                                            <g>
                                                <path fill="#4C8CCD" d="M11.6,18.1c-0.5,0-0.9-0.2-1.2-0.6l-0.9-1.1c-0.3,0-0.5,0-0.8,0l-0.9,1c-0.4,0.5-1.1,0.7-1.8,0.4l-0.9-0.4   c-0.6-0.3-1-0.9-0.9-1.6l0.1-1.4C4.2,14.4,4,14.2,3.8,14l-1.5,0.1c-0.6,0-1.2-0.4-1.4-1l-0.4-0.9c-0.3-0.6-0.1-1.3,0.5-1.8l1.1-0.9   c0-0.3,0-0.5,0-0.8L1,7.9C0.5,7.5,0.3,6.7,0.6,6.1L1,5.2c0.2-0.6,0.8-0.9,1.4-0.9l0.1,0L4,4.5C4.2,4.3,4.3,4.1,4.5,4L4.4,2.5   C4.3,1.8,4.7,1.2,5.3,1l0.9-0.4C6.9,0.3,7.6,0.5,8,1.1L9,2.2c0.2,0,0.4,0,0.6,0l1-1.2c0.4-0.5,1.2-0.7,1.8-0.4l0.9,0.4   c0.6,0.3,1,0.9,0.9,1.6L14,4.1c0.2,0.1,0.3,0.3,0.5,0.5l1.6-0.1c0.6,0,1.2,0.4,1.4,1l0.4,0.9C18.1,7,18,7.7,17.4,8.1L16.3,9   c0,0.2,0,0.5,0,0.7l1.1,0.9c0.5,0.4,0.7,1.2,0.4,1.8l-0.4,0.9c-0.2,0.6-0.8,0.9-1.4,0.9l-0.2,0l-1.4-0.1c-0.2,0.2-0.4,0.4-0.5,0.5   l0.1,1.4c0.1,0.7-0.3,1.3-1,1.6L12.2,18C12,18,11.8,18.1,11.6,18.1z M6.5,16.3C6.5,16.3,6.5,16.3,6.5,16.3L6.5,16.3z M11.5,16.3   C11.5,16.3,11.5,16.3,11.5,16.3L11.5,16.3z M10.3,14.5l1.4,1.7l0.5-0.2L12,13.8l0.4-0.3c0.4-0.3,0.7-0.6,0.9-0.9l0.3-0.4l2.2,0.2   l0.2-0.5l-1.7-1.4l0.1-0.5c0.1-0.4,0.1-0.8,0-1.3l-0.1-0.5l1.8-1.4l-0.2-0.5l-2.3,0.2l-0.3-0.4c-0.3-0.3-0.5-0.6-0.9-0.9l-0.4-0.3   l0.2-2.3l-0.5-0.2l-1.5,1.7L9.9,4.1C9.5,4,9.1,4,8.7,4.1L8.2,4.1L6.7,2.3L6.2,2.6l0.2,2.2L6,5.1C5.6,5.4,5.3,5.7,5.1,6L4.8,6.4   L2.5,6.1L2.3,6.7L4,8.1L3.9,8.6C3.9,9,3.9,9.5,3.9,9.9L4,10.4l-1.7,1.4l0.2,0.5l2.1-0.2l0.3,0.4c0.3,0.4,0.6,0.7,1,1l0.4,0.3   L6,15.9l0.5,0.2L8,14.5l0.5,0.1c0.5,0.1,0.9,0.1,1.4,0L10.3,14.5z M16.2,11.7C16.2,11.7,16.2,11.7,16.2,11.7L16.2,11.7z M2.2,6.8   L2.2,6.8C2.2,6.8,2.2,6.8,2.2,6.8z M12.6,2.7C12.6,2.7,12.6,2.7,12.6,2.7L12.6,2.7z M6.6,2.2C6.6,2.2,6.6,2.2,6.6,2.2L6.6,2.2z"></path>
                                            </g>
                                        </svg>
                                    </span>Settings</li> }
                                { server.metadata?.opType !== 'migration' && <li className="unrescue" onClick={ (e) => this.onUnrescueActionClick(e) }
                                    style={ { display: server.status.toLowerCase() === 'rescue' ? 'block' : 'none' } } >
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                            <path fill="#4C8CCD" d="M16.7,5.8L16,5.1c-0.3-0.3-0.8-0.4-1.2-0.1l-2.6,2c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0  c-0.4,0-0.7-0.3-0.7-0.7c0-0.2,0.1-0.4,0.3-0.5l2.1-2.1c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.5-0.3-0.6l-0.7-0.7  c-0.3-0.3-0.8-0.5-1.3-0.3l-4,1.2c-0.5,0.1-0.8,0.5-0.9,1L5.6,8.2l-4.2,4C1.2,12.6,1,13,1,13.4s0.2,0.9,0.5,1.2L2.8,16  c0.4,0.4,0.9,0.6,1.3,0.6c0.4,0,0.9-0.1,1.2-0.4l4.2-3.5l5.1-1.1c0.4-0.1,0.8-0.4,0.9-0.8L17,7.1C17.1,6.6,17,6.1,16.7,5.8z   M14.1,9.9l-5,1c-0.2,0-0.4,0.1-0.5,0.3l-4.3,3.6c0,0-0.1,0-0.1,0l-1.3-1.3L7,9.4C7.2,9.2,7.3,9,7.4,8.7l0.8-4.4l3-0.9L9.9,4.6  C9.7,4.9,9.5,5.2,9.5,5.5c-0.3,1.4,0,2.5,1,3c1.1,0.6,2.2,0.4,2.8-0.1L15.1,7L14.1,9.9z"></path>
                                        </svg>
                                    </span>Unrescue </li> }
                                { server.metadata?.opType !== 'migration' && <li className="retry" onClick={ (e) => this.onRetryClick(e, server) } style={ { display: server.status === 'ERROR' && server.taskState === "" && isBmr ? '' : 'none' } }>
                                    <span className="icon">
                                        <svg width="6.35mm" height="6.35mm" viewBox="0 0 18 18">
                                            <path d="M8.9.5a8.53,8.53,0,0,1,8.5,8h-2a6.51,6.51,0,1,0-6.5,7A6.43,6.43,0,0,0,13,14l-2.5-2.5h6v6l-2-2a8.27,8.27,0,0,1-5.5,2A8.49,8.49,0,0,1,.5,9,8.41,8.41,0,0,1,8.9.5Z" fill="#4c8ccd" fillRule="evenodd"></path>
                                        </svg>
                                    </span>Retry</li> }
                                { server.metadata?.opType !== 'migration' && <li className="rebuild" onClick={ (e) => { this.rebuildClick(e, server); e.stopPropagation(); } }
                                    style={ { display: ((server.status.toLowerCase() === 'active' || server.status.toLowerCase() === 'shutoff') && isBmr) ? '' : 'none' } } >
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 26 21.1" enableBackground="new 0 0 26 21.1" xmlSpace="preserve">
                                            <g>
                                                <path fill="none" stroke="#4C8CCA" strokeWidth="2.6769" strokeMiterlimit="10" d="M5.8,10c0-4.5,3.7-8.2,8.2-8.2c2.5,0,4.8,1.2,6.3,3"></path>
                                                <path fill="none" stroke="#4C8CCA" strokeWidth="2.6769" strokeMiterlimit="10" d="M22.2,10c0,4.5-3.7,8.2-8.2,8.2c-2.1,0-3.9-0.8-5.4-2"></path>
                                                <polygon fill="#4C8CCA" points="5.8,14.6 0.8,9.5 10.8,9.5"></polygon>
                                                <polygon fill="#4C8CCA" points="22.2,7.2 27.3,12.2 17.2,12.2"></polygon>
                                            </g>
                                        </svg>
                                    </span>
                                    Rebuild
                                </li> }

                                <li className="delete" style={ { display: !isMigrate ? 'block' : 'none' } }
                                    onClick={ (e) => this.onDeleteClick(e, server.flavor.id, server.status, server.fault, server) }>
                                    <span className="icon">
                                        <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M16.1,3.3v12c0,1.1-0.9,2-2,2h-10c-1.1,0-2-0.9-2-2v-12h-1v-2h3h1  v-1h8v1h1h3v2H16.1z M14.1,3.3h-10v12h10V3.3z M8.1,13.3h-2v-8h2V13.3z M12.1,13.3h-2v-8h2V13.3z"></path>
                                        </svg>
                                    </span>Delete</li>
                                { isMigrate && <li className="confirm_migrate" onClick={ (e) => this.confirmMigration(e, server, true) }> <span className="icon"> <svg x="0px" y="0px" viewBox="0 0 20 20" style={ { enableBackground: 'new 0 0 20 20' } } xmlSpace="preserve">
                                    <circle style={ { fill: 'none', stroke: '#4C8CCD', strokeWidth: '2', strokeMiterLimit: '10' } } cx="10" cy="10" r="8.8"></circle>
                                    <polyline style={ { fill: 'none', stroke: '#4C8CCD', strokeWidth: '2', strokeMiterLimit: '10' } } points="14.2,7 8.6,12.6 5.8,9.8 "></polyline>
                                </svg></span>Confirm Migration</li> }
                                { isMigrate && <li className="reverse_migrate" onClick={ (e) => this.revertMig(e, server) }> <span className="icon"> <svg x="0px" y="0px" viewBox="0 0 20 20" style={ { enableBackground: 'new 0 0 20 20' } } xmlSpace="preserve">
                                    <g>
                                        <polyline className="mi0" points="3.7,4.6 17.1,4.6 17.1,10.5    "></polyline>
                                        <polyline className="mi1" points="6,7.6 3,4.6 6,1.5    "></polyline>
                                        <polyline className="mi0" points="16.3,15.5 3,15.5 3,9.5  "></polyline>
                                        <polyline className="mi1" points="14,12.4 17.1,15.5 14,18.5  "></polyline>
                                    </g>
                                </svg></span>Revert Migration</li> }
                            </ul>
                        </span>
                    </div>
                </div>
                <div className="instance_migrate_wrap" style={ { display: isMigrate ? "" : "none" } }>
                    <div className="migration_info_content">
                        <div className="instance_migrate_title"><span>Verify this migrated instance and<a className={ server.status.toLowerCase() === "suspended" ? "delete_migrationBtn disabled" : "delete_migrationBtn" } href="#" onClick={ (e) => { this.confirmMigration(e, server, true); e.preventDefault(); } }>confirm</a> or <a href="#" className={ server.status.toLowerCase() === "suspended" ? "reverse_migrationBtn disabled" : "reverse_migrationBtn" } onClick={ (e) => this.revertMig(e, server) }>revert</a>.</span>
                            <span className="migrateinfo_icon" data-for="miginfoicon" data-tip onClick={ () => this.migInfo(server) }> <svg x="0px" y="0px" viewBox="0 0 19.8 19.8" style={ { enableBackground: 'new 0 0 19.8 19.8' } } xmlSpace="preserve">
                                <g>
                                    <circle className="inf0" cx="9.9" cy="9.9" r="7.1"></circle>
                                    <g>
                                        <line className="inf0" x1="9.9" y1="14" x2="9.9" y2="9"></line>
                                        <line className="inf0" x1="9.9" y1="7.8" x2="9.9" y2="5.8"></line>
                                    </g>
                                </g>
                            </svg>
                            </span> <ReactToolTip id="miginfoicon" place="top" effect="solid">Click to view migration details</ReactToolTip>
                            After 12 hours this instance will be automatically confirmed and the source instance will be deleted permanently.
                            <a href="https://www.idrivecompute.com/faq_instances.htm#migrate-instance" target="bn_left">Know more</a>
                        </div>
                    </div>
                </div>
                <div className="instance_backup_wrap" style={ { display: isBackup ? "block" : "none" } }>
                    <div className="instance_backup_content">
                        <p className="instance_backup_title"><span><strong>Enable Instance Backup:</strong> Protect your data and recover quickly in an emergency.</span><br></br>
                            A system image backup of the instance will be performed on a daily basis. An additional amount of <strong>$0.05/GB</strong> will be charged per month.</p>
                        <a className="common_cta_btn enableBkp" onClick={ () => this.createSchedule(server.id, server.name, server.region, server) }>Enable Backup</a>
                        <a data-tip data-for="banner" className="close_icon" onClick={ () => this.closeBanner(server) }></a>
                        <ReactToolTip id="banner" place="top" effect="solid"> close</ReactToolTip>
                    </div>
                </div>
                <div className="error_info_wrap" style={ { display: !server.isProgess && server.status.toLowerCase() === 'error' && this.checkInstCreationFault(String(server?.fault?.message)) ? "block" : "none" } }>
                    <div className="error_info_content">
                        <p className="err_title">The instance could not be created successfully. Any charges incurred will be refunded. You can try after some time or <a href='https://www.idrivecompute.com/support.htm' target={ "_blank" }>contact support</a> for assistance.</p>
                    </div>
                </div>
                <div className="boot_container" style={ { display: server.isProgess ? 'block' : 'none' } }>
                    <div className="boot_wrapper">
                        <div className="progress_wrap">
                            <div className="title_head"><span className="head_title">{ this.progressAction(server) }</span><span className="percent_num" id={ server.id }></span></div>
                            <div className="progress_bar"><span className="percent_progress" id={ server.id + 'per' } style={ { width: server.progressPerc + '%' } }></span></div>
                        </div>
                    </div>
                </div>
                {/* <div className="error_info_wrap" style={server.status === 'ERROR' && server.isProgess === undefined? {}: { display: 'none'}}>
                                                                    <div className="error_info_content">
                                                                        <p className="err_title">Failed to detect the instance</p>
                                                                    </div>
                                                                </div> */}
            </li >
        );
    };
    appendInstanceList = () => {
        let instList = [];
        for(let i = this.state.indexCount; i < this.state.filteredData.length && i < this.state.indexCount + this.state.count; i++) {
            let server = this.state.filteredData[i];
            instList.push(this.instReactElement(server, i));
        }
        return instList;
    };
    handlePreviousClick = (event) => {
        if(this.state.indexCount === 0) {
            this.setState({
                message: "Reached start of list, press next to display the rest",
            });
            return;
        } else {
            this.setState({
                indexCount: this.state.indexCount - this.state.count,
            });
            return;
        }
    };
    handleNextClick = (event) => {
        if(this.state.indexCount + this.state.count > this.state.filteredData.length - 1) {
            this.setState({
                message: "Reached end of list, no more instances to show"
            });
            return;
        } else {
            this.setState({
                indexCount: this.state.indexCount + this.state.count,
            });
        }
    };
    onPageChange = (event) => {
        if(event.target.value > 0) {
            let newIndexCount = (event.target.value - 1) * this.state.count;
            if(newIndexCount >= this.state.filteredData.length) {
                this.setState({
                    message: "Exceeded page limit, out of bounds",
                    msgType: "error",
                });
                this.pageNumFocus.current.focus();
            } else {
                this.setState({
                    indexCount: newIndexCount,
                });
            }
        }
    };
    setSelectionRange = (event) => {
        event.target.setSelectionRange(0, event.target.value.length);
    };
    checkInstCreationFault = (message) => {
        if(
            message.startsWith("Exceeded maximum number of retries. Exhausted all hosts available for retrying build failures for instance")
            || message.startsWith("No valid host was found")
            || message.indexOf("Last exception: Insufficient compute resources") !== -1
        ) return true;
        return false;
    };
    render() {

        return (
            <div>
                <div className={ this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "dashboard_module important_msg" : "dashboard_module" } data-gr-c-s-loaded="true">
                    <main>
                        <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                            <div className="loader_icon"></div>
                        </div>
                        {/* service will be discontinued start */ }
                        <div class="common_user_message service_discontinued" style={ { display: this.state.isCreateExternalDisabled ? 'block' : 'none' } }>
                            <div class="message_content">
                                {/* <p>The IDrive<sup>®</sup> Compute service will be discontinued from 15-August-2023. We request you to download and backup your data from your resources.</p> */ }
                                <p>The IDrive<sup>®</sup> Compute service has been discontinued since 15 August 2023.</p>
                            </div>
                        </div>
                        {/* service will be discontinued end */ }
                        <div className="common_user_message cluster_msg cluster_uiNew" style={ { display: this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "" : "none" } }>
                            <div className="message_content">
                                { this.state.regionCount == 1 ?
                                    <p><span className="cm_title">Region <b>{ this.state.regionString }</b> is under maintenance.  </span>
                                        You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                        <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                    </p>
                                    :
                                    <p><span className="cm_title">Regions <b>{ this.state.regionString }</b> are under maintenance.  </span>
                                        You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                        <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                    </p>
                                }
                                <span className="close_icon" data-tip data-for="closeCluster" onClick={ () => { this.setState({ isRegionStatus: false }); localStorage.setItem("clusterMessage", "hide"); } }></span>
                                <ReactToolTip id="closeCluster" place="left" effect="solid">Close</ReactToolTip>
                            </div>
                        </div>
                        <LeftNav isActive={ 'instances' }></LeftNav>
                        <div className="main_container">
                            <header className="header_wrap expand">
                                <HeaderTop isUserSubscribed={ this.state.isUserSubscribed } ></HeaderTop>
                                <div className="header_wrap_bottom">
                                    <div className="bottom_navbar">
                                        <div className="bn_left">
                                            <div className="computer_no">
                                                <span className="text bold_600">Instances </span>
                                                <span className="count_wrap">(
                                                    <span className="count">{ this.state.filteredData.length }</span>)</span>
                                            </div>
                                            <div className="head_progressWrap" style={ { display: this.state.isClone || this.state.isMigration ? '' : 'none' } }>
                                                <p className="clone_progress" style={ { display: this.state.isClone ? '' : 'none' } }>
                                                    <span>Cloning operation is in progress</span>
                                                    <a href="#" className="view_cloning" onClick={ (e) => { this.clonePopupOpen(); e.preventDefault(); } }>Click to view details</a>
                                                </p>
                                                <p className="migration_progress" style={ { display: this.state.isMigration ? '' : 'none' } }>
                                                    <span>Migration is in progress</span>
                                                    <a href="#" className="view_cloning" onClick={ (e) => { this.migPopupOpen(); e.preventDefault(); } }>Click to view details</a>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="bn_right">
                                            <div className="bn_searchbox">
                                                <div className="search_btn">
                                                    <svg className="header_search" viewBox="0 0 26 26">
                                                        <path
                                                            className="cls-1"
                                                            d="M11.33,5a6.33,6.33,0,1,0,6.34,6.32A6.32,6.32,0,0,0,11.33,5Zm0,10.84a4.52,4.52,0,1,1,4.52-4.52A4.52,4.52,0,0,1,11.33,15.85Z"></path>
                                                        <path className="cls-1" d="M14.3,15.58l1.28-1.28L21,19.72,19.73,21Z"></path>
                                                    </svg>
                                                </div>
                                                <input type="text" id="searchbox" className="input_searchbox" placeholder="Search" onKeyUp={ this.handleSearch } /></div>
                                            <div className="bn_dropdown" onClick={ this.bnDropdownClick }>
                                                <span className="icon">
                                                    <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                        <title>drop-down</title>
                                                        <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                    </svg>
                                                </span>

                                                <span className="default_option">{ this.state.dropDown }</span>
                                                <ul className="dropdown_component bn_dropdown_ul">
                                                    <span className="arrow_pointer"></span>
                                                    <li className="all_servers" onClick={ (e) => this.handleDropdown(e, "All Instances", "All Instances") }>All Instances</li>
                                                    <li className="active_servers" onClick={ (e) => this.handleDropdown(e, "Active", "Active") }>Active</li>
                                                    <li className="offline_servers" onClick={ (e) => this.handleDropdown(e, "SHUTOFF", "Shut Off") }>Shut Off</li>
                                                    <li className="error_servers" onClick={ (e) => this.handleDropdown(e, "Error", "Error") }>Error</li>
                                                    <li className="suspended_servers" onClick={ (e) => this.handleDropdown(e, "suspended", "Suspend") }>Suspend</li>
                                                    <li className="rescue_servers" onClick={ (e) => this.handleDropdown(e, "rescue", "Rescue") }>Rescue</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                            <NotificationSlider />

                            <section className="main_section pagination__wrap">
                                <Survey isUserSubscribed={ this.state.isUserSubscribed } />
                                <div className="main_body_container">
                                    <div className="mainBody_colWrap">
                                        <div className="colWrap_lhs expand">
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["name"]); } }>Name<span className="sort_icon" ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap" >IP Address
                                                                </div>
                                                            </div>
                                                            <div className="col col3">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["region"]); } }>Region<span className="sort_icon" ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["status"]); } }>Status<span className="sort_icon" ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col5">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["date"]); } }>Created On<span className="sort_icon active" ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col6">Actions</div>
                                                        </li>
                                                    </ul>
                                                    {/* {
                                                        this.state.filteredData.length > 50 && !this.state.isAction ?
                                                            <ul style={ { position: 'sticky' } }>
                                                                <li className="th">
                                                                    <div className="col col1" style={ { float: 'left', cursor: 'pointer' } }>
                                                                        <div onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                            Prev
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">
                                                                        -
                                                                    </div>
                                                                    <div className="col col3">
                                                                        <div>
                                                                            { this.state.indexCount + 1 } ... { (this.state.indexCount + 50) > this.state.filteredData.length ? this.state.filteredData.length : (this.state.indexCount + 50) }
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col4">
                                                                        -
                                                                    </div>
                                                                    <div className="col col5">
                                                                        -
                                                                    </div>
                                                                    <div className="col col6" style={ { float: "left", cursor: 'pointer' } }>
                                                                        <div onClick={ (event) => { this.handleNextClick(event); } }>
                                                                            Next
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul> :
                                                            null
                                                    } */}
                                                </div>
                                                {/* <div className="table_data" style={ { paddingBlockStart: this.state.filteredData.length > 50 ? "44px" : "" } }> */ }
                                                <div className='table_data'>
                                                    <ul id="appInstList">
                                                        {
                                                            this.state.filteredData.length === 0 && !this.state.isAction ?
                                                                <div className="outer_empty_wrap fullPageEmpty">
                                                                    <div className="inner_empty_wrap">
                                                                        <div className="svg_wrap empty_icon instanceCreate_empty"></div>
                                                                        { this.state.servers.length === 0 ?
                                                                            <div>
                                                                                <p className="empty_head">Instances</p>
                                                                                <p className="empty_title">Spin up a compute instance in seconds with required Linux distribution, CPU, RAM and Storage.</p>
                                                                                <div className="cta_wrap"> <input type="button" disabled={ this.state.isCreateExternalDisabled } value="Add Instances" onClick={ () => this.nextPath('/create') } className={ this.state.isCreateExternalDisabled ? "common_cta_btn blue disabled" : "common_cta_btn blue" } /></div>
                                                                            </div> : <p className="empty_head">No results found matching your search/selection</p> }
                                                                    </div>
                                                                </div> : this.appendInstanceList()
                                                        }
                                                    </ul >
                                                </div>
                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.filteredData.length > this.state.count ? "" : "none" } }>
                                                    <div className="Page_navigation">
                                                        <ul className="pagination_ul">
                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                                    <span aria-hidden="true">«</span>
                                                                    <span className="sr-only">Previous</span>
                                                                </a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                    {/* <input ref={ this.pageNumFocus } className="page-link" id="page-num" type="tel" name="Page Number" autoComplete="off" value={ Math.floor(this.state.indexCount / 50) + 1 } onClick={ (event) => { this.setSelectionRange(event); } } onChange={ (event) => { this.onPageChange(event); } }> */ }
                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.filteredData.length ? this.state.filteredData.length : (this.state.indexCount + this.state.count) }
                                                                    {/* </input> */ }
                                                                </a>
                                                            </li>
                                                            <li className={ this.state.indexCount + this.state.count > this.state.filteredData.length - 1 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                    <span aria-hidden="true">»</span>
                                                                    <span className="sr-only">Next</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div >
                                        </div >
                                        {/* <RightNav></RightNav> */ }
                                    </div >
                                </div >
                            </section >
                            <div className="main_slider">
                                <div className="slider_bg_shadow"></div>
                                <div className="slider_wrapper">
                                    <div className="main_slider_container">
                                        <div className="close_icon"></div>
                                        <div className="rhs_slide_ntwkStats">
                                            <div className="slide_ntwkStats_container">
                                                <div className="ntwrkTransPool_wrap">
                                                    <div className="title_head">Monthly Network Transfer Pool</div>
                                                    <div className="graph_wrap">
                                                        <div className="graph">
                                                            <div className="c100 p25 orange">
                                                                <span>25%</span>
                                                                <div className="slice">
                                                                    <div className="bar"></div>
                                                                    <div className="fill"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="graph_info">
                                                            <div className="row_used">
                                                                <span>3568 GB &nbsp;</span>
                                                                Used</div>
                                                            <div className="row_available">
                                                                <span>6242 GB &nbsp;</span>
                                                                Available</div>
                                                        </div>
                                                    </div>
                                                    <p className="pool_note">Your transfer is prorated and will reset next month</p>
                                                </div>
                                                <div className="bck_data_wrap">
                                                    <figure className="backup_cld">
                                                        <span className="svg_wrap"></span>
                                                    </figure>
                                                    <div className="title_head">Backup Your Data</div>
                                                    <p>Save image backups of your virtual machines in the cloud for high availability and new instance creation </p>
                                                    <input type="button" name="" value="Enable Now" className="common_cta_btn blue" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main >
                    {/* popup code start */ }

                    {/* Reboot Server popup Start */ }
                    <div className="main_popup reboot_server_pup" id="rebootPopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onRebootClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Reboot</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Are you sure you want to reboot the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="rebootBtn" onClick={ (e) => this.rebootClick(e) }>Reboot</button>
                                            <button className="btn btn_cancel" onClick={ () => this.onRebootClose() }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Reboot Server popup Ends */ }

                    {/* Power Off Server popup Start */ }
                    <div className="main_popup powOff_server_popup" id="poweroffPopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onPowerofClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Power Off</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Are you sure you want to power off the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="poweroffBtn" onClick={ this.powerOffClick }>Power Off</button>
                                            <button className="btn btn_cancel" onClick={ () => this.onPowerofClose() }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Power Off Server popup Ends */ }
                    {/* Restart popup Start */ }
                    <div className="main_popup restart_server_popup" id="startPoup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onStartClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">
                                            Start</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Are you sure you want to start the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button id="startBtn" className="btn btn_confirm" onClick={ this.startClick }>Start</button>
                                            <button className="btn btn_cancel" onClick={ () => this.onStartClose() }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Restart popup Ends */ }
                    {/* Delete popup Start */ }
                    <div className="main_popup delete_server_popup" id="deletePopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onDeleteClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Delete</div>
                                    </div>
                                    { this.state.currentFlavType == "Bare Metal" ?
                                        <div className="popup_body">
                                            <p className="imp_warn_note"><strong>Warning: </strong>This will permanently delete the bare metal instance from your account with all its data.

                                                The Bare Metal server will be released from your account and you may have to request for new server for new bare metal instance.</p>
                                            <p>Are you sure you want to delete the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                            <p><strong>Note:</strong> Any charges incurred will not be refunded on deleting the instance.</p>
                                        </div>
                                        :
                                        <div className="popup_body">
                                            <p className="imp_warn_note"><strong>Warning: </strong>This will permanently delete the instance from your account. On removing the instance, all its data and stored information will be deleted. This operation is irreversible.</p>
                                            <p>Are you sure you want to delete the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                            <p style={ { display: !(this.state.currentStatus.toLowerCase() === "error" && this.checkInstCreationFault(String(this.state?.currentFault?.message))) ? "" : "none" } }><strong>Note:</strong> Any charges incurred will not be refunded on deleting the prepaid yearly instance.</p>
                                        </div>

                                    }


                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="deleteBtn" onClick={ this.deleteClick }>Delete</button>
                                            <button className="btn btn_cancel" onClick={ () => this.onDeleteClose() }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_popup delete_server_popup" id="unrescuePopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onunrescueClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Unrescue</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Are you sure you want to unrescue the instance <b>{ this.state.selectedInstanceName }</b> ?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="unrescueBtn" onClick={ () => this.onUnrescueClick() }>Unrescue </button>
                                            <button className="btn btn_cancel" onClick={ () => this.onunrescueClose() }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_popup clone_details_popup" id="cloneDetailPopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onCloneClose() }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Instance clone requests</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Cloning operation is in progress. It may take some time to complete depending upon the size of the image.</p>
                                        <ul className="clone_table clone_table_det">
                                            {
                                                this.state.cloneList.map((elem, i) =>
                                                    <li className="clone_accordWrap" key={ i }>
                                                        <div className="clone_accorWrap_hd" onClick={ (e) => { this.toggleArrow(e); e.preventDefault(); } }>
                                                            <div className="instName">
                                                                <div className="server_icon">
                                                                    <div className="icon_img">
                                                                        <span className="icon">
                                                                            <svg x="0px" y="0px" width="17.9px" height="17.6px" viewBox="0 0 17.9 17.6" enableBackground="new 0 0 17.9 17.6" xmlSpace="preserve">
                                                                                <path className="st0" style={ { "fill": "#ffffff" } } d="M15.5,17.3h-8c-1.1,0-2-0.9-2-2v-8c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v8C17.5,16.4,16.6,17.3,15.5,17.3z
                                                                    M15.5,8.3c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V8.3z M10.5,3.3c0-0.6-0.4-1-1-1h-6
                                                                    c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h1v2h-2c-1.1,0-2-0.9-2-2v-8c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v2h-2V3.3z"></path>
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <span className="mig_instance">{ elem.instanceName }</span>
                                                            </div>

                                                            <span className="cloneInstStatus">Cloning</span>
                                                            <a href="#" className="openMigDet" onClick={ (e) => { e.preventDefault(); } }></a>
                                                        </div>
                                                        <div className="clone_accorWrap_bdy">
                                                            <p className="clone_intDet">
                                                                <span className="migr_detLabel">Source:</span>
                                                                <span data-tip data-for={ "cloneSourceInst" + i } >{ elem.sourceInstName }</span>
                                                                <ReactToolTip id={ "cloneSourceInst" + i } place="top" effect="solid">{ elem.sourceInstName }</ReactToolTip>

                                                            </p>
                                                            <p className="clone_intDet">
                                                                <span className="migr_detLabel">Source Region:</span>
                                                                <span>{ elem.srcRegion }</span>
                                                            </p>
                                                            <p className="clone_intDet">
                                                                <span className="migr_detLabel">Destination:</span>
                                                                <span data-tip data-for={ "cloneDestInst" + i } >{ elem.instanceName }</span>
                                                                <ReactToolTip id={ "cloneDestInst" + i } place="top" effect="solid">{ elem.instanceName }</ReactToolTip>
                                                            </p>
                                                            <p className="clone_intDet">
                                                                <span className="migr_detLabel">Destination Region:</span>
                                                                <span>{ elem.destRegion }</span>
                                                            </p>
                                                            <p className="clone_intDet">
                                                                <span className="migr_detLabel">Cloning start time:</span>
                                                                <span >{ elem.createdDate }</span>
                                                            </p>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                        </ul>

                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_cancel" onClick={ () => this.onCloneClose() }>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_popup migration_details_popup" id="migDetailPopup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.onCloneClose() } data-tip data-for="migDetailPopupClose"></span>
                                    <ReactToolTip id="migDetailPopupClose" place="left" effect="solid">Close</ReactToolTip>
                                    <div className="popup_header">
                                        <div className="sub_title">Migrate Instances</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Migration is in progress. It may take some time to complete depending upon the size of the instance.</p>
                                        <ul className="migration_table_det">
                                            {
                                                this.state.migList.map((elem, i) =>
                                                    <li className="migr_accordWrap" key={ i } >
                                                        <div className="migr_accorWrap_hd" onClick={ (e) => { this.toggleArrow(e); e.preventDefault(); } }>
                                                            <div className="instName">
                                                                <div className="server_icon">
                                                                    <div className="icon_img">
                                                                        <span className="icon">
                                                                            <svg x="0px" y="0px" width="20.9px" height="20px" viewBox="0 0 20.9 20" style={ { enableBackground: 'new 0 0 20.9 20' } } xmlSpace="preserve">
                                                                                <polyline className="rmi0" fill="#ffffff" points="11.1,10.3 6.3,10.3 6.3,13.4 1.1,8.4 6.3,3.3 6.3,6.4 12,6.4 "></polyline>
                                                                                <polyline className="rmi0" fill="#ffffff" points="9.8,10.3 14.6,10.3 14.6,7.1 19.8,12.2 14.6,17.3 14.6,14.1 8.9,14.1 "></polyline>
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <span className="mig_instance">{ elem.instanceName }</span>
                                                            </div>

                                                            <span className="migInstStatus">Migrating</span>
                                                            <a href="#" className="openMigDet" onClick={ (e) => { e.preventDefault(); } }></a>
                                                        </div>
                                                        <div className="migr_accorWrap_bdy">
                                                            <p className="migr_intDet">
                                                                <span className="migr_detLabel" >Source:</span>
                                                                <span data-tip data-for={ "migSourceInst" + i } >{ elem.sourceInstName }</span>
                                                                <ReactToolTip id={ "migSourceInst" + i } place="top" effect="solid">{ elem.sourceInstName }</ReactToolTip>

                                                            </p>
                                                            <p className="migr_intDet">
                                                                <span className="migr_detLabel" >Source Region:</span>
                                                                <span >{ getFullRegion(elem.srcRegion) }</span>

                                                            </p>
                                                            <p className="migr_intDet">
                                                                <span className="migr_detLabel" >Destination:</span>
                                                                <span data-tip data-for={ "destMiginst" + i }>{ elem.instanceName }</span>
                                                                <ReactToolTip id={ "destMiginst" + i } place="top" effect="solid">{ elem.instanceName }</ReactToolTip>

                                                            </p>
                                                            <p className="migr_intDet">
                                                                <span className="migr_detLabel" >Destination Region:</span>
                                                                <span>{ getFullRegion(elem.destRegion) }</span>

                                                            </p>
                                                            <p className="migr_intDet">
                                                                <span className="migr_detLabel">Migration start time:</span>
                                                                <span >{ elem.createdDate }</span>
                                                            </p>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_cancel" onClick={ () => this.onCloneClose() }>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main_popup delete_instance_popup" id="cnfmMig">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="tipcnfmMig" onClick={ () => { $('#cnfmMig').removeClass('active'); } }>
                                </span>
                                    <ReactToolTip place="left" effect="solid" id="tipcnfmMig">Close</ReactToolTip>
                                    <div className="popup_header">
                                        <div className="sub_title">Confirm Migration</div>
                                    </div>
                                    <div className="popup_body">
                                        <p> On confirming the migrated instance <b>{ this.state.selectedInstance.name }</b> in <b>{ this.state.selectedInstance?.fullRegion }</b>, the source instance <strong>{ this.state.srcServer?.name }</strong> with IP address <strong>{ this.state.srcServer?.mainIpAddress }</strong> in region<strong> { this.state.srcServer?.fullRegion }</strong> will be deleted permanently from your account. This action is irreversible. </p>
                                        <p>Are you sure you want to proceed?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn blue" id="cnfmBtn1" onClick={ (e) => this.confirmMigration(e, this.state.selectedInstance) }>Confirm</button>
                                            <button className="btn btn_cancel" onClick={ () => {
                                                $('#cnfmMig').removeClass('active'); $("body").removeClass("popup_no_scroll");
                                            } }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main_popup reverse_migration_popup" id="revertMig">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="closeRevertMig" onClick={ () => { $('#revertMig').removeClass('active'); } }></span>
                                    <ReactToolTip id="closeRevertMig" place="left" effect="solid">Close</ReactToolTip>

                                    <div className="popup_header">
                                        <div className="sub_title"> Revert Migration</div>
                                    </div>
                                    <div className="popup_body">
                                        <p> On reverting the migration of instance <strong>{ this.state.selectedInstance.name }</strong>, this instance with IP address <strong>{ this.state.selectedInstance.mainIpAddress }</strong> will be permanently deleted from region <strong> { this.state.selectedInstance.fullRegion }</strong>.</p>
                                        <p>Are you sure you want to proceed?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="revertCnf" onClick={ (e) => this.revertMigUpdate() }>Revert</button>
                                            <button className="btn btn_cancel" onClick={ () => {
                                                $('#revertMig').removeClass('active'); $("body").removeClass("popup_no_scroll");
                                            } }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_popup delete_instance_popup" id="cnfmDelMig">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="tipcnfmMig1" onClick={ () => { $('#cnfmDelMig').removeClass('active'); } }>
                                </span>
                                    <ReactToolTip place="left" effect="solid" id="tipcnfmMig1">Close</ReactToolTip>
                                    <div className="popup_header">
                                        <div className="sub_title">Confirm Migration</div>
                                    </div>
                                    <div className="popup_body">
                                        <p className="imp_warn_note"><strong>Warning: </strong>This will permanently delete the instance from your account. On removing the instance, all its data and stored information will be deleted. This operation is irreversible.</p>
                                        <p> On deleting the source instance <strong> { this.state.selectedInstance.name } </strong>, the migrated instance <strong>{ this.state.migServer?.name }</strong> with IP address <strong>{ this.state.migServer?.mainIpAddress }</strong> in region<strong> { this.state.migServer?.fullRegion }</strong> will be confirmed for the migration. This action is irreversible. </p>
                                        <p>Are you sure you want to proceed?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn blue" id="cnfmBtn" onClick={ (e) => this.confirmMigration(e, this.state.migServer) }>Confirm</button>
                                            <button className="btn btn_cancel" onClick={ () => {
                                                $('#cnfmDelMig').removeClass('active'); $("body").removeClass("popup_no_scroll");
                                            } }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="main_popup migration_info_popup" id="migInfo">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="tipcnfmMig" onClick={ () => {
                                    $('#migInfo').removeClass('active'); $("body").removeClass("popup_no_scroll");
                                }
                                }></span>
                                    <ReactToolTip place="left" effect="solid" id="tipcnfmMig">Close</ReactToolTip>
                                    <div className="popup_header">
                                        <div className="sub_title">Migration Details</div>
                                    </div>
                                    <div className="popup_body">
                                        <div className="migration_table">
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap">Source Instance</div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap">Migrated Instance</div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    <ul>
                                                        <li className="tr">
                                                            <div className="table_col_wrap">
                                                                <div className="col col1">
                                                                    <div className="mi_wrap"> <span className="mi_label">Name:</span> <span className="mi_text">{ this.state.srcServer?.name }</span> </div>
                                                                </div>
                                                                <div className="col col2">
                                                                    <div className="mi_wrap"> <span className="mi_label">Name:</span> <span className="mi_text">{ this.state.selectedInstance?.name }</span> </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="tr">
                                                            <div className="table_col_wrap">
                                                                <div className="col col1">
                                                                    <div className="mi_wrap"> <span className="mi_label">Region:</span> <span className="mi_text">{ this.state.srcServer?.fullRegion }</span> </div>
                                                                </div>
                                                                <div className="col col2">
                                                                    <div className="mi_wrap"> <span className="mi_label">Region:</span> <span className="mi_text"> { this.state.selectedInstance?.fullRegion } </span> </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="tr">
                                                            <div className="table_col_wrap">
                                                                <div className="col col1">
                                                                    <div className="mi_wrap"> <span className="mi_label">IP Address:</span> <span className="mi_text">{ this.state.srcServer?.mainIpAddress }</span> </div>
                                                                </div>
                                                                <div className="col col2">
                                                                    <div className="mi_wrap"> <span className="mi_label">IP Address:</span> <span className="mi_text">{ this.state.selectedInstance?.mainIpAddress }</span> </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <div className="btn btn_cancel" onClick={ () => {
                                                $('#migInfo').removeClass('active'); $("body").removeClass("popup_no_scroll");
                                            } }>Close</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <InstanceMigration selectedInstance={ this.state.selectedInstance } ref={ this.instMig } msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                    bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } getMigrationList={ () => this.getMigrationList() } />
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </div >
        );
    }

    componentWillUnmount() {
        $('link[title="dashboard"]').remove();
        clearInterval(sessionStorage.instanceListInterval);
        clearTimeout(sessionStorage.cloneListInterval);
        clearTimeout(sessionStorage.itemInterval);
        clearTimeout(sessionStorage.cloneInstTimeout);
        clearTimeout(sessionStorage.migInstTimeout);
        clearTimeout(sessionStorage.migListInterval);
        // clearTimeout(sessionStorage.flavorListTimeout);
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}

function getFullRegion(region) {

    let getOb = JSON.parse(localStorage.getItem('allRegionList'));
    if(getOb === null || getOb === undefined) {
        return region;
    }
    let regLi = getOb.find(item => item.region_id === region);
    if(regLi != undefined) {
        return regLi.name + ', ' + '(' + region + ')';
    }
    else {
        return region;
    }
};

function loadcss() {
    const link = document.createElement("link");
    link.href = "https://www.idrivecompute.com/webapp/css/dashboard.css";
    link.rel = "stylesheet";
    link.type = "text/css";
    link.title = "dashboard";
    document.head.appendChild(link);
    $('<link rel="stylesheet" href="https://www.idrivecompute.com/webapp/css/circle-progress.css" />').appendTo('head');
}
